/* sav-wizard-4.js - SILUMEN - v4 (portage de la v46 Silamp)
   Ecarts assumes par rapport a Silumen, verifies sur le catalogue Silumen :
     - productType EST renseigne -> la recherche d'equivalents par famille marche
     - conditionnement, guide video, fiche technique, alternative_en_stock ABSENTS
       -> pas de compteur de pack, pas de tutoriel video, pas d'equivalent curate
     - garantie renseignee ("2 ans") -> le moteur de garantie fonctionne
     - charte verte #2c6e3f (reprise de page.sav.liquid), pas l'orange Silumen
     - contexte B2B : SIRET, devis central, toggle HT/TTC
   Formulaire de contact UNIFIE : 11 branches (dont "Autre demande" classee par IA),
   autodiagnostic, documentation produit contextuelle (notice PDF, tutoriel video,
   fiche technique, guides), reprise du compte client connecte, et deflexion avant ticket.
   Remplace integralement v19..v26. v24 = durcissement, v25 = plus de fausse
   confirmation sans webhook d'envoi, v26 = plus de fausse COMMANDE sans webhook
   de recherche, v27 = ACCES RESERVE AUX CLIENTS CONNECTES.

   v27 : la recherche de commande par numero/email est abandonnee. Le client
   s'identifie en se connectant a son compte, et le formulaire lit ses commandes
   depuis la section Liquid (#sav-customer). Consequences :
     - plus aucun appel au webhook de recherche, plus de captcha ;
     - plus d'enumeration possible par numero de commande sequentiel ;
     - la commande n'est jamais saisie a la main, donc jamais fausse.
   Le niveau d'exigence se regle par data-gate :
     "commande" (DEFAUT) — connexion demandee sur les 3 premiers groupes de motifs
        (ma commande et ma livraison / un probleme avec ce que j'ai recu /
        retour et remboursement). "Avant d'acheter" et "Autre chose" restent
        ouverts a tous : ce sont des prospects, ils n'ont pas de commande.
     "tout" — connexion demandee pour tout le formulaire.
     "off"  — ancien comportement, recherche de commande par numero. Se pose par dessus sav-wizard-1/2/3.js (non modifies).

   Principe : 4 sorties, aucune autre.
     S1 resolu a l'ecran (aucun ticket)  S2 action de service (facture, alerte stock)
     S3 dossier complet a un agent       S4 routage commercial
   DEUX REGLES DE REDACTION, codees en dur :
   1. aucun ecran de fin ne dit "nous reviendrons vers vous" : on annonce toujours
      ce qui va se passer et a quelle echeance ;
   2. on n'annonce JAMAIS au client un traitement automatique, immediat ou "dans la
      journee". Toute decision est presentee comme prise en charge par un conseiller,
      avec une echeance. Ce qui est automatise l'est en interne, pas dans le discours.
*/
(function(){
  if(typeof S==='undefined'){
    try{
      var k=document.querySelector('#sav-root .card');
      if(k)k.innerHTML='<h2 class="q">Le formulaire n\'a pas pu se charger</h2>'
        +'<p class="sub">Rafraîchis la page. Si le problème persiste, écris-nous à '
        +'<a href="mailto:contact@silumen.com">contact@silumen.com</a> en indiquant votre numéro de commande : '
        +'nous traiterons votre demande normalement.</p>';
    }catch(e){}
    return;
  }

  /* ============================================================
     0. ENDPOINTS
     ============================================================ */
  /* ------------------------------------------------------------------
     DURCISSEMENT v24 — a lire avant de modifier
     1. esc() est redefini ici pour echapper AUSSI les guillemets. Le esc()
        de sav-wizard-1.js n'echappait que & < > : toute valeur injectee dans
        un attribut (href, src, value) pouvait en sortir avec un simple ".
        La redefinition corrige aussi les vues de sav-wizard-1/2/3.js, qui
        appellent le meme global.
     2. safeUrl() n'autorise que http(s), mailto et les chemins relatifs.
        Un metafield ou une reponse d'API contenant javascript:... ne peut
        plus devenir un lien cliquable.
     3. Les donnees affichees viennent de trois sources non maitrisees a
        100 % : le webhook de recherche de commande, les metafields produit,
        et les reponses de l'IA. Tout ce qui vient de la passe par esc()
        pour du texte et safeUrl() pour une URL. Sans exception.
     ------------------------------------------------------------------ */
  esc=function(s){
    return (s==null?'':(''+s))
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  };
  function safeUrl(u){
    var v=(u==null?'':(''+u)).trim();
    if(!v)return '';
    if(/^(https?:|mailto:)/i.test(v))return v;
    if(/^\/(?!\/)/.test(v))return v;             /* /pages/... mais pas //evil.com */
    if(/^[a-z][a-z0-9+.-]*:/i.test(v))return '';  /* javascript:, data:, vbscript:... */
    return '';
  }
  function safeImg(u){
    var v=(u==null?'':(''+u)).trim();
    if(/^data:image\/(png|jpe?g|gif|webp);base64,[A-Za-z0-9+/=]+$/.test(v))return v;
    /* Le filtre Liquid image_url renvoie une URL sans protocole (//cdn.shopify.com/...).
       safeUrl les refuse a juste titre pour des liens — un //evil.com est une
       redirection externe deguisee — mais sur une IMAGE le risque n'existe pas :
       une balise img n'execute rien. On les accepte donc ici, en https. */
    if(/^\/\/[A-Za-z0-9._-]+\//.test(v))return 'https:'+v;
    return safeUrl(v);
  }
  var ROOT=document.querySelector('#sav-root');
  /* attribut absent -> valeur par defaut ; attribut present mais vide -> desactive */
  function dset(k,def){
    try{
      var v=(ROOT&&ROOT.dataset)?ROOT.dataset[k]:undefined;
      return (v===undefined||v===null)?(def||''):(''+v).trim();
    }catch(e){return def||'';}
  }
  var DIAG_ENDPOINT = safeUrl(dset('diag','https://silampfrance.app.n8n.cloud/webhook/sav-diag-silumen'));
  var ACTION_ENDPOINT = safeUrl(dset('action','https://silampfrance.app.n8n.cloud/webhook/sav-action-silumen'));
  /* Equivalents en stock et documentation produit : workflow dedie (webhook
     sav-alt). Si le champ est vide, ces deux appels retombent sur le webhook
     de diagnostic — ce qui permet de fusionner les deux plus tard sans
     retoucher le theme. */
  /* Valeur par defaut, pour que les equivalents fonctionnent sans attendre le
     redeploiement de la section. Si la section fournit data-alt, elle gagne ;
     si elle le fournit VIDE, ces appels retombent sur le webhook de diagnostic. */
  var ALT_ENDPOINT = safeUrl(dset('alt','https://silampfrance.app.n8n.cloud/webhook/sav-alt-silumen'));
  /* Suivi : Shippingbo, pas Shopify. Shopify n'expose qu'UN numero de suivi par
     commande ; Shippingbo les a tous, ce qui change tout des qu'une commande
     part en plusieurs colis. */
  var SUIVI_ENDPOINT = safeUrl(dset('suivi','https://silampfrance.app.n8n.cloud/webhook/sav-suivi-silumen'));
  var GATE        = (dset('gate','commande')||'commande').toLowerCase();
  var URL_LOGIN   = safeUrl(dset('login','/account/login'))||'/account/login';
  /* Page reelle du formulaire de devis : /pages/devis
     (« Formulaire de devis FR (2020) », suffixe formulaire-de-devis) */
  var URL_DEVIS   = safeUrl(dset('devis','/pages/devis'))||'/pages/devis';
  var URL_COMPTE  = safeUrl(dset('compte','/account'))||'/account';
  var URL_CGV     = safeUrl(dset('cgv','/pages/conditions-generales-de-vente'))||'';
  var TS_SITEKEY  = '0x4AAAAAAD3KRSvMRSoUSmUM';

  /* ============================================================
     1. ETAT
     ============================================================ */
  S.diagByProd={}; S.qty={}; S.upack={}; S.diagResult={};
  S.lines={};        /* branche prepa : {idx:{on:1,type:'manquant|qte|mauvais',qte:n}} */
  S.checks={};       /* cases de verification */
  S.attest=null;     /* {text,at,branche} */
  S.decision=null;   /* reexpedition | remboursement | attendre | echange | avoir | numeraire */
  S.alt=null;        /* alternatives produit renvoyees par l'IA */
  S.sortie='S3';     /* sortie effective au moment de l'envoi */
  S.flags={};        /* qualite / securite / express / recidive */
  S.escal='';        /* raison d'escalade */
  S.res={};          /* ressources produit (notice, video, fiche, guides) par cle produit */
  S.srcProduit=null; /* produit identifie par sav-alt : sert a renvoyer vers sa fiche */
  S.cust=null;       /* compte client connecte, injecte par la section Liquid */
  S._manual=false;   /* le client a demande la saisie manuelle d'une commande */
  S._tsToken=''; S._tsWidget=null; S._case=null;

  /* ============================================================
     2. CSS
     ============================================================ */
  try{
    var css=''
    +'body #sav-root .wrap,body #sav-root .reassure,body #sav-root .block,body #sav-root .conditions,body #sav-root .sav-hero-in{max-width:1480px}'
    +'body #sav-root .msgedit{width:100%;min-height:300px;background:#fafafa;border:1px solid var(--sav-line);border-radius:10px;padding:18px 20px;font-family:inherit;font-size:15.5px;line-height:1.7;resize:vertical}'
    +'body #sav-root .msgview{width:100%;min-height:300px;background:#fafafa;border:1px solid var(--sav-line);border-radius:10px;padding:18px 20px;font-family:inherit;font-size:15.5px;line-height:1.7;white-space:pre-wrap}'
    +'body #sav-root .msgview b{font-weight:700;color:#1a1a1a}'
    +'body #sav-root .prod .pimg,body #sav-root .prod .pph{width:56px;height:56px;border-radius:8px;flex:0 0 auto;border:1px solid var(--sav-line)}'
    +'body #sav-root .prod .pimg{object-fit:cover;background:#fff}'
    +'body #sav-root .prod .pph{background:linear-gradient(135deg,#ffd9c4,#2c6e3f)}'
    +'body #sav-root .qtywrap{margin-top:10px;font-size:13.5px;color:var(--sav-grey);display:flex;align-items:center;gap:8px;flex-wrap:wrap}'
    +'body #sav-root .qtywrap select,body #sav-root .qtywrap input{width:70px;padding:6px 10px;font-size:14px}'
    +'body #sav-root .dprod{border:1px solid var(--sav-line);border-radius:12px;padding:16px 18px;margin-bottom:16px;background:#fff}'
    +'body #sav-root .dprod-h{display:flex;align-items:center;gap:12px;margin-bottom:4px}'
    +'body #sav-root .dprod-h img{width:50px;height:50px;object-fit:cover;border-radius:8px;border:1px solid var(--sav-line);flex:0 0 auto}'
    +'body #sav-root .dprod ul{margin:6px 0 0;padding-left:20px}body #sav-root .dprod li{margin:5px 0;font-size:15px;line-height:1.5}'
    /* --- groupes de motifs --- */
    +'body #sav-root .mgroup{margin:22px 0 6px;font-family:Montserrat,sans-serif;font-weight:700;font-size:13px;letter-spacing:.06em;text-transform:uppercase;color:var(--sav-grey)}'
    +'body #sav-root .mgrid{display:grid;grid-template-columns:1fr 1fr;gap:14px}'
    +'body #sav-root .mtile{border:1px solid var(--sav-line);border-radius:12px;padding:16px 18px;background:#fff;cursor:pointer;transition:border-color .15s,box-shadow .15s;display:flex;gap:12px;align-items:flex-start}'
    +'body #sav-root .mtile:hover,body #sav-root .mtile:focus{border-color:#2c6e3f;box-shadow:0 2px 10px rgba(235,111,51,.12);outline:none}'
    +'body #sav-root .mtile.sel{border-color:#2c6e3f;background:#f0f7ed}'
    +'body #sav-root .mtile .ic{font-size:20px;line-height:1.2}'
    +'body #sav-root .mtile .t{font-family:Montserrat,sans-serif;font-weight:600;font-size:16px;color:#1a1a1a}'
    +'body #sav-root .mtile .d{font-size:14px;color:var(--sav-grey);margin-top:3px;line-height:1.45}'
    +'body #sav-root .mtile .lock{display:inline-block;font-family:Lato,sans-serif;font-weight:400;font-size:11.5px;color:var(--sav-grey);background:#f2f2f2;border-radius:6px;padding:2px 7px;margin-left:8px;vertical-align:2px;white-space:nowrap}'
    /* --- statut / bandeaux --- */
    +'body #sav-root .stat{border-radius:12px;padding:16px 18px;margin:14px 0;border:1px solid var(--sav-line);background:#fafafa}'
    +'body #sav-root .stat.ok{border-color:#bcdcb4;background:#f2f9f0}'
    +'body #sav-root .stat.warn{border-color:#d4e8cd;background:#fff7ec}'
    +'body #sav-root .stat.bad{border-color:#e8b1a2;background:#fdf1ee}'
    +'body #sav-root .stat h4{margin:0 0 6px;font-family:Montserrat,sans-serif;font-size:17px;font-weight:700;color:#1a1a1a}'
    +'body #sav-root .stat p{margin:6px 0 0;font-size:15px;line-height:1.6}'
    +'body #sav-root .kv{display:flex;flex-wrap:wrap;gap:6px 26px;margin-top:12px;font-size:14.5px}'
    +'body #sav-root .kv span{color:var(--sav-grey)}body #sav-root .kv b{color:#1a1a1a}'
    +'body #sav-root .badge{display:inline-block;font-family:Montserrat,sans-serif;font-size:12px;font-weight:600;padding:3px 9px;border-radius:7px;margin-left:8px;vertical-align:middle}'
    +'body #sav-root .badge.in{background:#e7f4e2;color:#2f6b25}'
    +'body #sav-root .badge.out{background:#f5e6e2;color:#8a3a24}'
    /* --- choix de decision --- */
    +'body #sav-root .dec{border:1px solid var(--sav-line);border-radius:12px;padding:15px 17px;margin-bottom:12px;background:#fff;cursor:pointer;display:flex;gap:12px;align-items:flex-start}'
    +'body #sav-root .dec:hover{border-color:#2c6e3f}'
    +'body #sav-root .dec.sel{border-color:#2c6e3f;background:#f0f7ed}'
    +'body #sav-root .dec .r{width:18px;height:18px;border-radius:50%;border:2px solid #c9c9c9;flex:0 0 auto;margin-top:2px}'
    +'body #sav-root .dec.sel .r{border-color:#2c6e3f;box-shadow:inset 0 0 0 4px #2c6e3f}'
    +'body #sav-root .dec .t{font-family:Montserrat,sans-serif;font-weight:600;font-size:15.5px;color:#1a1a1a}'
    +'body #sav-root .dec .d{font-size:14px;color:var(--sav-grey);margin-top:3px;line-height:1.45}'
    /* --- cases a cocher / attestation --- */
    +'body #sav-root .ck{display:flex;gap:11px;align-items:flex-start;padding:11px 0;font-size:15px;line-height:1.55;cursor:pointer}'
    +'body #sav-root .ck input{width:19px;height:19px;flex:0 0 auto;margin-top:2px;accent-color:#2c6e3f}'
    +'body #sav-root .attest{border:1px solid var(--sav-line);border-left:3px solid #2c6e3f;border-radius:10px;background:#fafafa;padding:15px 17px;margin:16px 0}'
    +'body #sav-root .attest .txt{font-size:14.5px;line-height:1.65;color:#3a3a3a;margin:8px 0 0;font-style:italic}'
    /* --- lignes de commande (branche prepa) --- */
    +'body #sav-root .line{border:1px solid var(--sav-line);border-radius:12px;padding:14px 16px;margin-bottom:12px;background:#fff}'
    +'body #sav-root .line.on{border-color:#2c6e3f}'
    +'body #sav-root .line-h{display:flex;gap:12px;align-items:center}'
    +'body #sav-root .line-h img{width:46px;height:46px;object-fit:cover;border-radius:8px;border:1px solid var(--sav-line);flex:0 0 auto}'
    +'body #sav-root .line-h .n{font-weight:600;font-size:15px;line-height:1.35}'
    +'body #sav-root .line-h .s{font-size:13px;color:var(--sav-grey);margin-top:2px}'
    +'body #sav-root .subm{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0 0 58px}'
    +'body #sav-root .subm button{font-family:Montserrat,sans-serif;font-size:13.5px;font-weight:600;padding:7px 13px;border-radius:7px;border:1px solid var(--sav-line);background:#fff;color:#1a1a1a;cursor:pointer}'
    +'body #sav-root .subm button.on{border-color:#2c6e3f;background:#f0f7ed;color:#245a34}'
    /* --- gabarit photo --- */
    +'body #sav-root .slots{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-top:6px}'
    +'body #sav-root .slot{border:1px dashed #cfcfcf;border-radius:12px;padding:14px;background:#fafafa;cursor:pointer;position:relative;min-height:150px;display:flex;flex-direction:column;gap:8px}'
    +'body #sav-root .slot:hover{border-color:#2c6e3f;background:#fff}'
    +'body #sav-root .slot.filled{border-style:solid;border-color:#bcdcb4;background:#fff}'
    +'body #sav-root .slot .st{font-family:Montserrat,sans-serif;font-weight:600;font-size:14.5px;color:#1a1a1a}'
    +'body #sav-root .slot .sd{font-size:13px;color:var(--sav-grey);line-height:1.45}'
    +'body #sav-root .slot .ex{height:74px;border-radius:8px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;overflow:hidden}'
    +'body #sav-root .slot .ex svg{width:100%;height:100%}'
    +'body #sav-root .slot img.prev{width:100%;height:74px;object-fit:cover;border-radius:8px}'
    +'body #sav-root .slot .rmv{position:absolute;top:8px;right:8px;border:none;background:rgba(26,26,26,.75);color:#fff;width:24px;height:24px;border-radius:50%;cursor:pointer;font-size:13px;line-height:1}'
    +'body #sav-root .slot .tagreq{font-size:11.5px;font-family:Montserrat,sans-serif;font-weight:600;color:#245a34}'
    /* --- alternatives produit --- */
    +'body #sav-root .alt{display:flex;gap:14px;align-items:center;border:1px solid var(--sav-line);border-radius:12px;padding:13px 15px;margin-bottom:12px;background:#fff}'
    +'body #sav-root .alt img{width:64px;height:64px;object-fit:cover;border-radius:8px;border:1px solid var(--sav-line);flex:0 0 auto}'
    +'body #sav-root .alt .n{font-weight:600;font-size:15px;line-height:1.35}'
    +'body #sav-root .alt .p{font-size:14px;color:var(--sav-grey);margin-top:3px}'
    +'body #sav-root .alt .go{margin-left:auto;flex:0 0 auto}'
    +'body #sav-root .actions{display:flex;gap:12px;flex-wrap:wrap;margin-top:24px}'
    /* --- ressources produit : notice, video, fiche, guides --- */
    +'body #sav-root .reslist{display:flex;flex-direction:column;gap:10px;margin-top:14px}'
    +'body #sav-root .resl{display:flex;align-items:center;gap:10px;border:1px solid var(--sav-line);border-radius:10px;padding:11px 14px;background:#fff;text-decoration:none;color:#1a1a1a;font-size:15px;font-weight:600;font-family:Montserrat,sans-serif}'
    +'body #sav-root .resl:hover{border-color:#2c6e3f;color:#245a34}'
    +'body #sav-root .resl .rsub{font-family:Lato,sans-serif;font-weight:400;font-size:13.5px;color:var(--sav-grey)}'
    +'body #sav-root .yt{display:flex;gap:14px;align-items:center;border:1px solid var(--sav-line);border-radius:10px;padding:11px 14px;background:#fff;cursor:pointer}'
    +'body #sav-root .yt:hover{border-color:#2c6e3f}'
    +'body #sav-root .ytthumb{position:relative;width:132px;height:74px;flex:0 0 auto;border-radius:8px;overflow:hidden;background:#e9e9e9}'
    +'body #sav-root .ytthumb img{width:100%;height:100%;object-fit:cover;display:block}'
    +'body #sav-root .ytthumb .play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:24px;text-shadow:0 1px 6px rgba(0,0,0,.55)}'
    +'body #sav-root .yt .n{font-family:Montserrat,sans-serif;font-weight:600;font-size:15px;line-height:1.35;color:#1a1a1a}'
    +'body #sav-root .yt .p{font-size:13.5px;color:var(--sav-grey);margin-top:4px;line-height:1.45}'
    +'body #sav-root .ytframe{position:relative;padding-top:56.25%;border-radius:10px;overflow:hidden;margin-top:14px;background:#000}'
    +'body #sav-root .ytframe iframe{position:absolute;inset:0;width:100%;height:100%;border:0}'
    /* --- commandes du compte client --- */
    +'body #sav-root .hello{display:flex;align-items:center;gap:10px;font-size:14.5px;color:var(--sav-grey);margin-bottom:16px}'
    +'body #sav-root .hello b{font-family:Montserrat,sans-serif;color:#1a1a1a;font-weight:600}'
    +'body #sav-root .ordt{border:1px solid var(--sav-line);border-radius:12px;padding:15px 17px;margin-bottom:12px;background:#fff;cursor:pointer;display:flex;gap:14px;align-items:center;transition:border-color .15s}'
    +'body #sav-root .ordt:hover{border-color:#2c6e3f}'
    +'body #sav-root .ordt.sel{border-color:#2c6e3f;background:#f0f7ed}'
    +'body #sav-root .ordt.off{opacity:.55}'
    +'body #sav-root .ordt .thumbs3{display:flex;flex:0 0 auto}'
    +'body #sav-root .ordt .thumbs3 img,body #sav-root .ordt .thumbs3 .ph{width:44px;height:44px;border-radius:8px;border:2px solid #fff;box-shadow:0 0 0 1px var(--sav-line);object-fit:cover;background:linear-gradient(135deg,#ffd9c4,#2c6e3f)}'
    +'body #sav-root .ordt .thumbs3 :not(:first-child){margin-left:-14px}'
    +'body #sav-root .ordt .oi{flex:1 1 auto;min-width:0}'
    +'body #sav-root .ordt .oi .t{font-family:Montserrat,sans-serif;font-weight:600;font-size:15.5px;color:#1a1a1a}'
    +'body #sav-root .ordt .oi .d{font-size:13.5px;color:var(--sav-grey);margin-top:3px}'
    +'body #sav-root .ordt .stt{font-family:Montserrat,sans-serif;font-size:12px;font-weight:600;padding:3px 9px;border-radius:7px;background:#f0f0f0;color:#555;flex:0 0 auto}'
    +'body #sav-root .ordt .stt.ok{background:#e7f4e2;color:#2f6b25}'
    +'body #sav-root .ordt .stt.go{background:#f0f7ed;color:#245a34}'
    /* rythme vertical du bas de page : resserre sous le formulaire,
       respiration conservee seulement apres la FAQ */
    +'body #sav-root .wrap{margin-bottom:0;padding-bottom:0}'
    +'body #sav-root .reassure{margin-top:18px;margin-bottom:18px}'
    +'body #sav-root .conditions{margin-top:0}'
    +'body #sav-root .block.faq{margin-top:26px;margin-bottom:72px}'
    +'@media(max-width:740px){body #sav-root .reassure{margin-top:12px;margin-bottom:12px}body #sav-root .block.faq{margin-top:18px;margin-bottom:48px}}'
    +'body #sav-root .colis{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px 12px;padding:10px 0;border-top:1px solid var(--sav-line);font-size:14.5px}'
    +'body #sav-root .colis:first-of-type{border-top:0}'
    +'body #sav-root .colis .n{font-family:Montserrat,sans-serif;font-weight:600;font-size:13px;color:var(--sav-grey);min-width:64px}'
    +'body #sav-root .colis .num{font-family:\'JetBrains Mono\',monospace;font-weight:600;color:#1a1a1a}'
    +'body #sav-root .colis .et{font-size:12.5px;font-family:Montserrat,sans-serif;font-weight:600;padding:2px 8px;border-radius:6px;background:#f0f0f0;color:#555}'
    +'body #sav-root .colis .et.ok{background:#e7f4e2;color:#2f6b25}'
    +'body #sav-root .colis .et.go{background:#f0f7ed;color:#245a34}'
    +'body #sav-root .colis a{margin-left:auto}'
    +'body #sav-root .draft{border:1px solid #d4e8cd;background:#fff7ec;border-radius:12px;padding:15px 17px;margin-bottom:20px}'
    +'body #sav-root .draft b{font-family:Montserrat,sans-serif}'
    +'body #sav-root .muted{font-size:13.5px;color:var(--sav-grey);line-height:1.55;margin-top:14px}'
    /* --- responsive : PC large / petit PC / tablette / mobile / petit mobile --- */
    +'@media(max-width:1200px){body #sav-root .wrap,body #sav-root .reassure,body #sav-root .block,body #sav-root .conditions,body #sav-root .sav-hero-in{max-width:1100px}}'
    +'@media(max-width:900px){body #sav-root .cgrid{grid-template-columns:1fr 1fr}body #sav-root .mgrid{grid-template-columns:1fr}body #sav-root .slots{grid-template-columns:1fr 1fr}}'
    +'@media(max-width:740px){body #sav-root .yt{flex-wrap:wrap}body #sav-root .ytthumb{width:100%;height:150px}body #sav-root .card{padding:18px}body #sav-root h2.q{font-size:20px}body #sav-root .sav-hero h1{font-size:24px}body #sav-root .panel{padding:18px 16px}body #sav-root .reassure{grid-template-columns:1fr 1fr}body #sav-root .slots{grid-template-columns:1fr}body #sav-root .subm{margin-left:0}body #sav-root .alt{flex-wrap:wrap}body #sav-root .alt .go{margin-left:0;width:100%}}'
    +'@media(max-width:380px){body #sav-root .nav{flex-direction:column-reverse}body #sav-root .nav .btn{width:100%}body #sav-root .cgrid,body #sav-root .grid,body #sav-root .reassure{grid-template-columns:1fr}body #sav-root .actions .btn{width:100%}}';
    var st=document.createElement('style');st.setAttribute('data-sav','w');st.textContent=css;document.body.appendChild(st);
  }catch(e){}

  /* ============================================================
     3. UTILITAIRES
     ============================================================ */
  var MOIS=['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
  var MOISA=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  var JOURS=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];

  function parseDate(v){
    if(!v)return null;
    if(v instanceof Date)return v;
    var s=(''+v).trim();
    var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if(m)return new Date(+m[1],+m[2]-1,+m[3]);
    m=/^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s);
    if(m)return new Date(+m[3],+m[2]-1,+m[1]);
    var d=new Date(s);return isNaN(d.getTime())?null:d;
  }
  function frDate(v){var d=parseDate(v);if(!d)return v||'';return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear();}
  function frLong(v){
    var d=parseDate(v);if(!d)return v||'';
    var an=(d.getFullYear()!==new Date().getFullYear())?(' '+d.getFullYear()):'';
    return JOURS[d.getDay()]+' '+d.getDate()+' '+MOISA[d.getMonth()]+an;
  }
  function daysBetween(a,b){var d1=parseDate(a),d2=parseDate(b)||new Date();if(!d1)return null;return Math.floor((d2-d1)/86400000);}
  function monthsBetween(a,b){
    var d1=parseDate(a),d2=parseDate(b)||new Date();if(!d1)return null;
    return (d2.getFullYear()-d1.getFullYear())*12+(d2.getMonth()-d1.getMonth())-(d2.getDate()<d1.getDate()?1:0);
  }
  function addOuvres(n,from){
    var d=from?new Date(parseDate(from).getTime()):new Date();var i=0;
    while(i<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)i++;}
    return d;
  }
  function engagement(n){return frLong(addOuvres(n||1));}
  /* Defectueux : le traitement depend du volume de dossiers en cours (retour
     usine, controle de lot). On annonce une fourchette plutot qu'une date ferme
     a un jour ouvre, qu'on ne tient pas en periode de pic. */
  function delaiSAV(){
    var g=payloadGarantie();
    var concerne=(S.motif==='defaut')&&(!g||g.statut!=='inconnu');
    return concerne
      ? 'sous 24 à 72 h ouvrées, selon le volume de demandes en cours'
      : 'avant le '+engagement(1);
  }
  function ageTexte(m){
    if(m==null)return '';
    var a=Math.floor(m/12),r=m%12,t=[];
    if(a)t.push(a+' an'+(a>1?'s':''));
    if(r)t.push(r+' mois');
    return t.join(' et ')||'moins d\'un mois';
  }
  function esc2(s){return esc(s==null?'':(''+s));}
  function money(v){if(v==null||v==='')return '';var n=parseFloat((''+v).replace(',','.'));if(isNaN(n))return ''+v;return n.toFixed(2).replace('.',',')+' EUR';}
  function orderMode(){return !(S.noOrder||!S.order);}
  function ful(){return (S.order&&S.order.fulfillment)||{};}
  function ship(){return (S.order&&S.order.shipping)||{};}

  /* --- moteur de garantie --- */
  /* accepte 36, "36", "36 mois", "5 ans", "5 ANS" (metafield custom.garantie) */
  function moisDe(v){
    if(v==null||v==='')return 0;
    var t=(''+v).toLowerCase().replace(',','.');
    var m=/(\d+(?:\.\d+)?)\s*an/.exec(t);
    if(m)return Math.round(parseFloat(m[1])*12);
    m=/(\d+)\s*mois/.exec(t);
    if(m)return parseInt(m[1],10);
    m=/^\s*(\d+)\s*$/.exec(t);
    if(m){var n=parseInt(m[1],10);return n<=10?n*12:n;} /* un nombre nu <=10 = des annees */
    return 0;
  }
  function garantieMois(p){
    var sp=(p&&p.specs)||{};
    var m=Math.max(moisDe(sp.garantie_mois),moisDe(sp.garantie));
    return Math.max(24,m); /* legale 24 mois minimum - a confirmer juridiquement */
  }
  function garantieDe(p){
    var base=(S.order&&(S.order.date||S.order.created_at))||null;
    var mois=garantieMois(p),age=monthsBetween(base);
    if(age==null)return {known:false,mois:mois};
    return {known:true,mois:mois,age:age,in:age<=mois,reste:Math.max(0,mois-age),date:base};
  }
  function garantieOut(){
    /* vrai seulement si TOUS les produits selectionnes sont hors garantie */
    var l=posList(),ok=0,tot=0;
    for(var i=0;i<l.length;i++){
      var p=productAtPos(l[i]);if(!p)continue;
      var g=garantieDe(p);if(!g.known)continue;
      tot++;if(!g.in)ok++;
    }
    return tot>0&&ok===tot;
  }
  function joursDepuisReception(){
    var f=ful();
    return daysBetween(f.delivered_at||f.shipped_at||(S.order&&S.order.date));
  }

  /* ============================================================
     4. FICHIERS ET GABARIT PHOTO
     ============================================================ */
  function savDownscale(file,cb){
    try{
      var url=URL.createObjectURL(file);var img=new Image();
      img.onload=function(){
        var w=img.width,h=img.height,max=1600;
        if(w>max||h>max){var r=Math.min(max/w,max/h);w=Math.round(w*r);h=Math.round(h*r);}
        var c=document.createElement('canvas');c.width=w;c.height=h;
        c.getContext('2d').drawImage(img,0,0,w,h);
        var out=null;try{out=c.toDataURL('image/jpeg',0.72);}catch(e){}
        URL.revokeObjectURL(url);cb(out,Math.min(img.width,img.height));
      };
      img.onerror=function(){URL.revokeObjectURL(url);cb(null,0);};img.src=url;
    }catch(e){cb(null,0);}
  }
  function readRaw(file,cb){
    try{var fr=new FileReader();fr.onload=function(e){cb(e.target.result);};fr.onerror=function(){cb(null);};fr.readAsDataURL(file);}
    catch(e){cb(null);}
  }
  var MAX_FILES=8, MAX_TOTAL=9*1024*1024;   /* garde-fou charge utile */
  function poidsFiles(){
    var n=0;for(var i=0;i<S.files.length;i++){if(S.files[i].data)n+=S.files[i].data.length;}
    return n;
  }
  function pushFile(f,slot,after){
    if(!slot&&S.files.length>=MAX_FILES){if(after)after();return;}
    var item={name:f.name,type:f.type||'',thumb:null,data:null,slot:slot||'',small:false};
    S.files.push(item);
    var nm=(f.name||'').toLowerCase();
    var looksImg=(f.type&&f.type.indexOf('image')===0)||/\.(jpe?g|png|gif|webp|heic|heif|bmp|tiff?)$/.test(nm);
    var big=f.size&&f.size>10485760;
    if(looksImg){
      savDownscale(f,function(out,minSide){
        item.small=(minSide>0&&minSide<800);
        if(out){
          if(poidsFiles()+out.length>MAX_TOTAL){item.thumb=out;item.tooBig=true;if(after)after();return;}
          item.data=out;item.thumb=out;item.type='image/jpeg';if(after)after();return;
        }
        if(!big){readRaw(f,function(raw){if(raw){item.data=raw;item.thumb=item.thumb||raw;}if(after)after();});}else{if(after)after();}
      });
    }else if(!big){readRaw(f,function(raw){
      if(raw&&poidsFiles()+raw.length<=MAX_TOTAL)item.data=raw;else item.tooBig=true;
      if(after)after();});}
    else{if(after)after();}
  }
  addFiles=function(list){[].slice.call(list).forEach(function(f){pushFile(f,'',paintFiles);});paintFiles();};

  /* gabarits imposes par branche (plan de mise en oeuvre, section 11) */
  var GABARIT={
    casse:[
      {id:'g1',t:'1 - Le carton fermé, tel que reçu',d:"C'est la photo la plus importante : elle nous dit si le dommage vient du transport ou de notre emballage.",req:true,ex:'box'},
      {id:'g2',t:'2 - Le carton ouvert, calage visible',d:"Elle nous dit si nous avons assez protégé le produit.",req:true,ex:'open'},
      {id:'g3',t:'3 - Le produit endommagé, en gros plan',d:"Cadrez bien la zone cassée.",req:true,ex:'zoom'},
      {id:'g4',t:'4 - L\'étiquette transporteur (facultatif)',d:"Avec le numéro de suivi lisible.",req:false,ex:'label'}
    ],
    prepa:[
      {id:'g1',t:'1 - Le colis ouvert, contenu visible',d:"Vue d'ensemble : on doit voir ce qu'il y a dedans.",req:true,ex:'open'},
      {id:'g2',t:'2 - L\'étiquette du colis',d:"Avec le numéro de suivi lisible. Elle sert au contrôle de préparation.",req:true,ex:'label'},
      {id:'g3',t:'3 - Le produit reçu (si ce n\'est pas le bon)',d:"Photo de l'étiquette du produit reçu à la place.",req:false,ex:'zoom'}
    ],
    defaut:[
      {id:'g1',t:'1 - Le produit installé',d:"En place, dans son environnement, allumé si possible.",req:true,ex:'lamp'},
      {id:'g2',t:'2 - L\'étiquette du produit',d:"Référence et numéro de lot lisibles : c'est ce qui permet de tracer la série.",req:true,ex:'label'},
      {id:'g3',t:'3 - Une courte vidéo (si le défaut est intermittent)',d:"Scintillement, clignotement, coupure : 10 secondes suffisent.",req:false,ex:'video'}
    ]
  };
  var EXSVG={
    box:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><rect x="26" y="18" width="68" height="44" rx="3"/><path d="M26 30h68M60 18v44"/></svg>',
    open:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><path d="M30 30h60v32H30z"/><path d="M30 30l-8-12h34l4 12M90 30l8-12H64l-4 12"/></svg>',
    zoom:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><circle cx="54" cy="34" r="18"/><path d="M67 47l14 14M46 34h16"/></svg>',
    label:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><rect x="28" y="20" width="64" height="38" rx="3"/><path d="M36 30h20M36 38h34M36 46h28"/><path d="M76 28v22M80 28v22M84 28v22"/></svg>',
    lamp:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><path d="M60 14a14 14 0 00-8 25v6h16v-6a14 14 0 00-8-25z"/><path d="M54 52h12M56 58h8"/></svg>',
    video:'<svg viewBox="0 0 120 74" fill="none" stroke="#b9b9b9" stroke-width="2"><rect x="30" y="22" width="44" height="30" rx="4"/><path d="M78 30l14-6v26l-14-6z"/></svg>'
  };
  function gabaritFor(){
    if(S.motif==='casse')return GABARIT.casse;
    if(S.motif==='prepa')return GABARIT.prepa;
    if(S.motif==='defaut')return GABARIT.defaut;
    return null;
  }
  function fileInSlot(id){for(var i=0;i<S.files.length;i++){if(S.files[i].slot===id)return S.files[i];}return null;}
  function clearSlot(id){S.files=S.files.filter(function(f){return f.slot!==id;});}

  /* ============================================================
     5. IDENTIFICATION DE LA COMMANDE
     Si le client est connecte, la section Liquid a injecte son compte et ses
     commandes dans #sav-customer : on ne demande plus rien, on propose.
     ============================================================ */
  try{
    var _cel=document.getElementById('sav-customer');
    var _raw=_cel?((_cel.getAttribute('data-json')||_cel.textContent||'').trim()):'';
    if(_raw){
      var _c=JSON.parse(_raw);
      if(_c&&_c.logged_in)S.cust=_c;
    }
  }catch(e){S.cust=null;}
  /* Le formulaire est-il ferme a ce visiteur ? */
  function gateActive(){
    if(S.cust)return false;
    if(GATE==='off')return false;
    if(GATE==='commande')return !!(S.motif&&NEED_ORDER[S.motif]);
    return true;
  }
  VIEWS.login=function(){
    var m=S.motif&&MOTIFS[S.motif];
    return '<div class="step-label">Connexion</div>'
      +'<h2 class="q">Connectez-vous pour continuer</h2>'
      +'<p class="sub">'+(m?('Pour traiter « '+esc2(m.t)+' », votre commande nous est nécessaire. '):'')
      +'Aucun numéro ne vous sera demandé : une fois connecté, vos commandes s\'affichent et vous sélectionnez celle qui pose problème. '
      +'Articles, garantie et suivi se chargent avec.</p>'
      +'<div class="stat ok"><h4>Pas besoin de créer un compte ni de retenir un mot de passe</h4>'
      +'<p>Saisissez l\'adresse email utilisée lors de votre commande : vous recevez un code à 6 chiffres et vous êtes connecté. '
      +'Vos commandes y sont déjà rattachées, même si vous avez commandé sans créer de compte.</p></div>'
      +'<div class="actions">'
      +'<a class="btn primary" href="'+esc2(URL_LOGIN)+'">Me connecter →</a>'
      +(GATE==='commande'?'<button class="btn ghost" id="autresujet">← Choisir un autre sujet</button>':'')
      +'</div>'
      +'<p class="muted">Vous avez commandé sur une marketplace (Amazon, ManoMano, Leroy Merlin…) ? '
      +'Votre commande n\'est pas rattachée à un compte Silumen : passe par la messagerie de la marketplace, '
      +'c\'est là que votre dossier sera traité le plus rapidement.</p>'
      +'<p class="muted">Un problème pour vous connecter ? Écris-nous à '
      +'<a href="mailto:contact@silumen.com">contact@silumen.com</a> en indiquant votre numéro de commande.</p>';
  };
  /* Une commande annulee n'a jamais ete expediee : aucun SAV ne peut la
     concerner. Elle est donc ECARTEE de la liste — la ranger en fin de liste ne
     suffisait pas, elle continuait a encombrer le choix.
     Une commande REMBOURSEE reste affichee : elle a bien ete livree, et un
     remboursement partiel ou un retour peut encore faire l'objet d'une demande. */
  function custOrders(){
    return ((S.cust&&S.cust.orders)||[]).filter(function(o){
      if(!o||!o.id)return false;
      if(o.cancelled)return false;
      if(String(o.financial_status||'').toLowerCase()==='voided')return false;
      return true;
    });
  }
  function prenom(){
    var n=((S.cust&&S.cust.name)||'').trim();
    return n?n.split(/\s+/)[0]:'';
  }
  /* le statut Liquid (fulfilled / partial) n'est pas celui du transporteur : on normalise */
  function normOrder(o){
    var c=JSON.parse(JSON.stringify(o));
    var f=c.fulfillment||{};
    var st=(f.status||'').toLowerCase();
    if(st==='fulfilled'||st==='partial'||st==='complete')st='in_transit';
    if(!st)st=f.tracking?'in_transit':'unfulfilled';
    f.status=st;c.fulfillment=f;
    c.source='compte';
    return c;
  }
  function statutOrder(o){
    if(o.cancelled)return {t:'Annulée',c:'off'};
    var fs=((o.fulfillment&&o.fulfillment.status)||'').toLowerCase();
    var pay=(o.financial_status||'').toLowerCase();
    if(pay==='refunded')return {t:'Remboursée',c:''};
    if(fs==='fulfilled'||fs==='complete'||fs==='in_transit')return {t:'Expédiée',c:'ok'};
    if(fs==='partial')return {t:'Partiellement expédiée',c:'go'};
    return {t:'En préparation',c:'go'};
  }
  try{
    if(TS_SITEKEY&&GATE!=='tout'&&!document.querySelector('script[data-sav-ts]')){
      var tss=document.createElement('script');
      tss.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      tss.async=true;tss.defer=true;tss.setAttribute('data-sav-ts','1');
      document.head.appendChild(tss);
    }
  }catch(e){}
  function renderTurnstile(){
    if(!TS_SITEKEY)return;
    var el=SGID('cfts');if(!el)return;
    if(el.getAttribute('data-rendered'))return;
    if(!window.turnstile){setTimeout(renderTurnstile,300);return;}
    try{
      S._tsWidget=window.turnstile.render(el,{sitekey:TS_SITEKEY,
        callback:function(tok){S._tsToken=tok;},
        'expired-callback':function(){S._tsToken='';},
        'error-callback':function(){S._tsToken='';}});
      el.setAttribute('data-rendered','1');
    }catch(e){}
  }
  function resetTurnstile(){
    S._tsToken='';
    try{if(window.turnstile&&S._tsWidget!=null)window.turnstile.reset(S._tsWidget);}catch(e){}
  }
  function setOrder(o){
    S.order={
      id:o.id||'',date:o.date||'',email:o.email||'',name:o.name||'',phone:o.phone||'',
      products:o.products||[],channel:o.channel||'',
      shipping:o.shipping||{},fulfillment:o.fulfillment||{},invoice:o.invoice||{},
      total:o.total||'',cancelled:!!o.cancelled,financial_status:o.financial_status||'',
      source:o.source||'lookup'
    };
    S.noOrder=false;S.diagByProd={};S.qty={};S.upack={};S.diagResult={};S.lines={};S.alt=null;
    /* Une recherche par numero de commande seul ne prouve rien : les numeros
       sont sequentiels. On ne recopie donc PAS l'email ni le telephone du
       client dans le formulaire — ils seraient lisibles par n'importe qui
       ayant deviné un numéro. Prefill autorise seulement si l'identification
       s'est faite par email ou depuis le compte connecte. */
    if(S.order.source==='compte'||S._lkMode==='email'){
      if(o.email)S.contact.email=o.email;
      if(o.name&&!S.contact.nom)S.contact.nom=o.name;
      if(o.phone&&!S.contact.tel)S.contact.tel=o.phone;
    }
    render();
  }
  function normOrders(d){
    if(d&&d.orders&&d.orders.length)return d.orders;
    if(d&&d.found&&d.id)return [d];
    return [];
  }
  function showChoices(orders){
    var wrap=SGID('ordselwrap'),sel=SGID('ordselect');if(!sel)return;
    sel.innerHTML='<option value="">— sélectionnez votre commande —</option>'+orders.map(function(o,i){return '<option value="'+i+'">'+esc2(o.id)+(o.date?' · '+esc2(frDate(o.date)):'')+'</option>';}).join('');
    if(wrap)wrap.style.display='block';
    sel.onchange=function(){if(sel.value==='')return;setOrder(orders[+sel.value]);};
  }
  function doLookup(){
    var ep=dset('endpoint','');
    var ordEl=SGID('ord'),mailEl=SGID('mail'),eid=SGID('e_id');
    var ord=(ordEl?ordEl.value:'').trim();
    var mail=(mailEl?mailEl.value:'').trim();
    if(!ord&&!validEmail(mail)){if(eid){eid.textContent='Renseignez un numéro de commande ou un email valide.';eid.style.display='block';}return;}
    if(eid)eid.style.display='none';
    if(!ep){
      /* Sans webhook de recherche, on ne FABRIQUE PAS une commande : un client
         qui verrait la commande de demonstration croirait qu'on lui affiche la
         sienne. Le mode demo reste accessible pour les maquettes via
         data-demo="1" sur #sav-root. */
      if(dset('demo','')==='1'){
        var mo=JSON.parse(JSON.stringify(MOCK_ORDER));mo.id=ord||MOCK_ORDER.id;mo.email=mail||'';setOrder(mo);return;
      }
      if(eid){
        eid.textContent='La recherche automatique n\'est pas disponible pour le moment. '
          +'Poursuivez sans votre numéro de commande : un conseiller la retrouvera avec votre nom et votre email.';
        eid.style.display='block';
      }
      return;
    }
    if(TS_SITEKEY&&!S._tsToken){if(eid){eid.textContent='Merci de valider la vérification anti-robot juste au-dessus du bouton.';eid.style.display='block';}return;}
    S._lkMode=ord?'order':'email';
    var body=ord?{order:ord}:{email:mail};
    body.cf_token=S._tsToken||'';body.motif=S.motif||'';
    var key=ord?('o:'+ord):('e:'+mail);
    if(S._lastLk===key&&S.order)return;
    S._lastLk=key;
    var btn=SGID('lookup');if(btn){btn.disabled=true;btn.textContent='Recherche…';}
    var lctrl=('AbortController' in window)?new AbortController():null;
    var ltimer=setTimeout(function(){if(lctrl)lctrl.abort();},20000);
    fetch(ep,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:lctrl?lctrl.signal:undefined})
      .then(function(r){clearTimeout(ltimer);return r.json();})
      .then(function(d){
        if(btn){btn.disabled=false;btn.textContent='Retrouver ma commande';}
        resetTurnstile();
        if(d&&d.error==='captcha'){if(eid){eid.textContent='La vérification anti-robot a échoué. Réessaie.';eid.style.display='block';}return;}
        var orders=normOrders(d);
        if(!orders.length){if(eid){eid.textContent='Aucune commande trouvée avec ces informations. Vérifiez le numéro, ou essayez avec votre email.';eid.style.display='block';}return;}
        if(orders.length===1){setOrder(orders[0]);}else{showChoices(orders);}
      })
      .catch(function(){clearTimeout(ltimer);S._lastLk=null;resetTurnstile();if(btn){btn.disabled=false;btn.textContent='Retrouver ma commande';}if(eid){eid.textContent='Vérification indisponible pour le moment. Vous pouvez poursuivre sans numéro.';eid.style.display='block';}});
  }

  /* ============================================================
     6. MOTIFS - le point d'entree unique
     ============================================================ */
  for(var _k in MOTIFS){if(MOTIFS.hasOwnProperty(_k))delete MOTIFS[_k];}
  MOTIFS.suivi   ={ico:'🚚',t:'Où est ma commande ?',d:'Suivi, délai, colis en retard'};
  MOTIFS.nonrecu ={ico:'📭',t:'Colis annoncé livré, jamais reçu',d:'Le transporteur indique livré, vous n\'avez rien reçu'};
  MOTIFS.casse   ={ico:'📦',t:'Colis ou produit abîmé',d:'Cassé ou endommagé à la réception'};
  MOTIFS.prepa   ={ico:'🧩',t:'Article manquant ou erreur',d:'Il manque un article, ou ce n\'est pas le bon'};
  MOTIFS.defaut  ={ico:'⚡',t:'Produit défectueux ou en panne',d:'Ne s\'allume pas, clignote, ne fonctionne plus'};
  MOTIFS.retract ={ico:'↩️',t:'Retour, échange, rétractation',d:'Le produit ne convient pas'};
  MOTIFS.facture ={ico:'🧾',t:'Ma facture',d:'La récupérer ou la recevoir par mail'};
  MOTIFS.conseil ={ico:'💡',t:'Conseil ou question produit',d:'Compatibilité, installation, choix'};
  MOTIFS.stock   ={ico:'📅',t:'Disponibilité, rupture de stock',d:'Être alerté du retour en stock'};
  MOTIFS.devis   ={ico:'📐',t:'Devis, projet, tarif pro',d:'Chantier, quantité, revente'};
  MOTIFS.autre   ={ico:'💬',t:'Autre demande',d:'Votre situation n\'est pas dans la liste ? Décrivez-la, nous vous orientons'};

  var GROUPES=[
    {t:'Ma commande et ma livraison',k:['suivi','nonrecu','facture']},
    {t:'Un problème avec ce que j\'ai reçu',k:['casse','prepa','defaut']},
    {t:'Retour et remboursement',k:['retract']},
    {t:'Avant d\'acheter',k:['conseil','stock','devis']},
    {t:'Autre chose',k:['autre']}
  ];
  var NEED_ORDER={suivi:1,nonrecu:1,facture:1,casse:1,prepa:1,defaut:1,retract:1};
  var ORDER_STRICT={suivi:1,nonrecu:1,facture:1};

  VIEWS.motif=function(){
    var h=draftHtml()
      +'<div class="step-label">Étape 1 · Votre demande</div>'
      +'<h2 class="q">Comment pouvons-nous vous aider ?</h2>'
      +'<p class="sub">Sélectionnez le sujet le plus proche : nous traitons un maximum de cas directement ici, sans attente.</p>';
    GROUPES.forEach(function(g){
      h+='<div class="mgroup">'+esc2(g.t)+'</div><div class="mgrid">';
      g.k.forEach(function(k){
        var m=MOTIFS[k];if(!m)return;
        var lock=(!S.cust&&GATE!=='off'&&(GATE==='tout'||NEED_ORDER[k]));
        h+='<div class="mtile '+(S.motif===k?'sel':'')+'" data-k="'+k+'">'
          +'<div class="ic">'+m.ico+'</div>'
          +'<div><div class="t">'+esc2(m.t)+(lock?'<span class="lock">🔒 connexion</span>':'')+'</div>'
          +'<div class="d">'+esc2(m.d)+'</div></div></div>';
      });
      h+='</div>';
    });
    h+='<div class="err" id="e_motif">Sélectionnez un sujet.</div>'
      +'<p class="muted">Une demande commerciale (devis, chantier, revente) part directement au pôle commercial et ne passe pas par le SAV.'
      +((!S.cust&&GATE==='commande')?' Les sujets marqués 🔒 concernent une commande : une connexion vous sera demandée, sans mot de passe, pour la retrouver.':'')
      +'</p>';
    return h;
  };
  function setupMotif(){
    var dr=SGID('drep');
    if(dr)dr.onclick=function(){applyDraft(S._draft);};
    var dn=SGID('dnew');
    if(dn)dn.onclick=function(){S._draft=null;clearDraft();render();};
    app.querySelectorAll('.mtile').forEach(function(el){
      clickable(el,function(){
        S.motif=el.dataset.k;S.selProducts=[];S.famille=null;S.answers={};
        S.lines={};S.checks={};S.attest=null;S.decision=null;S.alt=null;S.escal='';S.flags={};S.upack={};
        S.files=[];S.step=1;render();
      });
    });
  }

  /* ============================================================
     7. IDENTIFICATION (ecran)
     ============================================================ */
  function ordTileHtml(o,i){
    var st=statutOrder(o),prods=o.products||[];
    var th=prods.slice(0,3).map(function(p){
      var im=safeImg(p.image);
      return im?('<img src="'+esc2(im)+'" alt="" loading="lazy">'):'<span class="ph"></span>';
    }).join('')||'<span class="ph"></span>';
    var sel=(S.order&&S.order.id===o.id);
    var n=prods.length||parseInt(o.lines,10)||0;
    return '<div class="ordt '+(sel?'sel':'')+(o.cancelled?' off':'')+'" data-oi="'+i+'">'
      +'<span class="thumbs3">'+th+'</span>'
      +'<span class="oi"><span class="t">'+esc2(o.id)+'</span>'
      +'<span class="d">'+esc2(frLong(o.date))+' · '+n+' article'+(n>1?'s':'')
      +(o.total?' · '+esc2(money(o.total)):'')+'</span></span>'
      +'<span class="stt '+st.c+'">'+esc2(st.t)+'</span></div>';
  }
  function avertAnnulee(){
    if(!S.order||!S.order.cancelled)return '';
    return '<div class="stat warn"><h4>Cette commande a été annulée</h4>'
      +'<p>Aucun colis n\'a été expédié. Si vous attendez un remboursement ou si l\'annulation ne vient pas de vous, '
      +'poursuivez : un conseiller reprendra le dossier.</p></div>';
  }
  VIEWS.id=function(){
    var o=S.order,strict=!!ORDER_STRICT[S.motif],list=custOrders();
    var ferme=(GATE!=='off');
    var compte=(list.length>0&&(!S._manual||ferme));
    if(ferme&&S.cust&&!list.length){
      /* Connecte mais aucune commande rattachee : on ne renvoie pas vers une
         recherche qui n'existe plus, on laisse decrire la demande. */
      return '<div class="step-label">Étape 2 · Votre commande</div>'
        +'<div class="hello">👤 Connecté'+(prenom()?' en tant que <b>'+esc2(prenom())+'</b>':'')+'</div>'
        +'<h2 class="q">Aucune commande rattachée à ce compte</h2>'
        +'<p class="sub">Si vous avez commandé avec une autre adresse email, déconnectez-vous et reconnectez-vous avec celle-ci : '
        +'vos commandes y sont rattachées automatiquement. Sinon, poursuivez : un conseiller retrouvera votre commande avec votre nom.</p>'
        +'<div class="actions"><a class="btn ghost" href="'+esc2(URL_LOGIN)+'">Changer de compte</a>'
        +'<button class="btn primary" id="skip">Continuer sans commande →</button></div>';
    }
    if(compte){
      var p=prenom();
      var h='<div class="step-label">Étape 2 · Votre commande</div>'
        +'<div class="hello">👤 Connecté'+(p?' en tant que <b>'+esc2(p)+'</b>':'')+'</div>'
        +'<h2 class="q">'+(p?'Bonjour '+esc2(p)+', quelle commande ?':'Quelle commande est concernée ?')+'</h2>'
        +'<p class="sub">Vos commandes ont été reprises depuis votre compte : vous n\'avez rien à ressaisir. Sélectionnez celle qui pose problème, les articles, la garantie et le suivi se chargent avec elle.</p>';
      var VISIBLES=6;
      var tout=S._toutesCmd||list.length<=VISIBLES;
      list.forEach(function(od,i){if(tout||i<VISIBLES)h+=ordTileHtml(od,i);});
      if(!tout){
        var reste=list.length-VISIBLES;
        h+='<div style="margin:4px 0 14px"><button class="link" id="plusCmd">Afficher mes '
          +reste+' autre'+(reste>1?'s':'')+' commande'+(reste>1?'s':'')+'</button></div>';
      }
      if(o)h+='<div class="order"><b>Commande sélectionnée : '+esc2(o.id)+'</b><div class="hint">'+((o.products&&o.products.length)||0)+' article(s) — vous sélectionnerez le produit concerné à l\'étape suivante.</div></div>';
      h+='<div class="err" id="e_id">Sélectionnez la commande concernée.</div>'
        +(ferme?'<p class="muted">Une commande plus ancienne, ou passée avec une autre adresse ? Déconnectez-vous et reconnectez-vous avec l\'email utilisé lors de l\'achat.</p>'
               :'<div style="margin-top:16px"><button class="link" id="manual">Une autre commande, ou une commande passée sans compte</button></div>')
        +(strict?'':'<div style="margin-top:10px"><button class="link" id="skip">Ma demande ne concerne aucune commande</button></div>')
        +'<div class="nav"><button class="btn ghost" id="back">← Retour</button>'
        +'<button class="btn primary" id="next" '+((o||S.noOrder)?'':'disabled')+'>Continuer →</button></div>';
      return h;
    }
    return ''
    +'<div class="step-label">Étape 2 · Votre commande</div>'
    +(S.cust?'<div class="hello">👤 Connecté'+(prenom()?' en tant que <b>'+esc2(prenom())+'</b>':'')+(list.length?'':' — aucune commande rattachée à ce compte')+'</div>':'')
    +'<h2 class="q">Retrouvons votre commande</h2>'
    +'<p class="sub">Numéro de commande <b>ou</b> email : nous récupérons le reste automatiquement — suivi, articles, garantie.</p>'
    +'<label class="f">Numéro de commande <span class="hint">(ex : #291234 — dans le mail de confirmation)</span></label>'
    +'<input type="text" id="ord" placeholder="#291234" value="'+esc2(o?o.id:(S.answers.ordlibre||''))+'">'
    +'<label class="f">Email de la commande</label>'
    +'<input type="email" id="mail" placeholder="vous@email.fr" value="'+esc2((o&&S._lkMode==='email')?(o.email||''):(S.contact.email||''))+'">'
    +'<div id="ordselwrap" style="display:none"><label class="f">Vos commandes</label><select id="ordselect"></select></div>'
    +'<div id="cfts" style="margin-top:16px"></div>'
    +'<div class="err" id="e_id">Renseignez un numéro de commande ou un email valide.</div>'
    +'<button class="btn ghost" id="lookup" style="margin-top:14px">Retrouver ma commande</button>'
    +(o?'<div class="order"><b>Commande trouvée : '+esc2(o.id)+'</b>'+(o.date?' · '+esc2(frDate(o.date)):'')+'<div class="hint">'+((o.products&&o.products.length)||0)+' article(s).</div></div>':'')
    +(strict
      ? '<p class="muted">Pour ce sujet, la commande nous est nécessaire pour consulter votre suivi et votre facture. Si vous ne retrouvez rien, essayez avec l\'email utilisé lors de l\'achat.</p>'
        +'<div style="margin-top:10px"><button class="link" id="skip">Je ne retrouve vraiment pas ma commande</button></div>'
      : '<div style="margin-top:16px"><button class="link" id="skip">Je n\'ai pas mon numéro de commande</button></div>')
    +(custOrders().length?'<div style="margin-top:10px"><button class="link" id="backcompte">← Revenir à mes commandes</button></div>':'')
    +'<div class="nav"><button class="btn ghost" id="back">← Retour</button>'
    +'<button class="btn primary" id="next" '+((o||S.noOrder)?'':'disabled')+'>Continuer →</button></div>';
  };
  function setupId(){
    var list=custOrders();
    var ferme=(GATE!=='off');
    if(ferme&&S.cust&&!list.length){
      var sk1=SGID('skip');
      if(sk1)sk1.onclick=function(){S.noOrder=true;S.order=null;S.escal='client connecté sans commande rattachée';S.step++;render();};
      return;
    }
    if(list.length&&(!S._manual||ferme)){
      app.querySelectorAll('.ordt').forEach(function(el){
        clickable(el,function(){
          var od=list[+el.dataset.oi];if(!od)return;
          setOrder(normOrder(od));
        });
      });
      var pc=SGID('plusCmd');
      if(pc)pc.onclick=function(){S._toutesCmd=true;render();};
      var mn=SGID('manual');
      if(mn&&!ferme)mn.onclick=function(){S._manual=true;S.order=null;render();};
      var sk0=SGID('skip');
      if(sk0)sk0.onclick=function(){S.noOrder=true;S.order=null;S.escal='demande hors commande';S.step++;render();};
      return;
    }
    var bc=SGID('backcompte');
    if(bc)bc.onclick=function(){S._manual=false;S.order=null;render();};
    renderTurnstile();
    var lk=SGID('lookup');if(lk)lk.onclick=doLookup;
    var sk=SGID('skip');if(sk)sk.onclick=function(){S.noOrder=true;S.order=null;S.escal='commande introuvable';S.step++;render();};
    var ordEl=SGID('ord');if(ordEl)ordEl.onblur=function(){if(ordEl.value.trim())doLookup();};
    var mailEl=SGID('mail');if(mailEl)mailEl.onblur=function(){var o=SGID('ord');if((!o||!o.value.trim())&&validEmail(mailEl.value.trim()))doLookup();};
  }

  /* ============================================================
     8. HELPERS PRODUITS
     ============================================================ */
  function selCount(){return orderMode()?Math.max(1,(S.selProducts||[]).length):1;}
  function idxAt(pos){return (S.selProducts||[])[pos];}
  function productAtPos(pos){var idx=idxAt(pos);return (orderMode()&&idx!=null&&S.order.products)?S.order.products[idx]:null;}
  function prodKeyAt(pos){var idx=idxAt(pos);return (orderMode()&&idx!=null)?('p'+idx):'free';}
  function posList(){
    if(!orderMode())return [0];
    var n=(S.selProducts||[]).length;if(!n)return [0];
    var a=[];for(var i=0;i<n;i++)a.push(i);return a;
  }
  function qtyAt(pos){var idx=idxAt(pos);var p=productAtPos(pos);if(!p)return 1;return S.qty[idx]||p.q||1;}
  /* conditionnement : nombre d'unites contenues dans un pack / lot, 0 si ce n'est pas un pack */
  function packSize(p){
    if(!p)return 0;
    var sp=p.specs||{};
    var raw=sp.pack_qty||sp.conditionnement||sp.unites_par_pack||'';
    var mv=/(\d{1,4})/.exec(''+raw);
    var v=mv?parseInt(mv[1],10):0;
    if(!isNaN(v)&&v>1)return v;
    var t=((p.n||'')+' '+(p.variant||''));
    var m=/(?:pack|lot|set|blister|bo[iî]te|kit)\s*(?:de\s*|d'|x\s*)?(\d{1,4})/i.exec(t);
    if(m&&+m[1]>1)return +m[1];
    m=/\(\s*x\s*(\d{1,4})\s*\)/i.exec(t);
    if(m&&+m[1]>1)return +m[1];
    m=/^PACK(\d{1,4})/i.exec(skuOf(p));
    if(m&&+m[1]>1)return +m[1];
    return 0;
  }
  function upackAt(pos){
    var idx=idxAt(pos),p=productAtPos(pos),n=packSize(p);
    if(!n)return 0;
    var v=S.upack[idx];
    if(v==null||v==='')return n;
    v=parseInt(v,10);if(isNaN(v))return n;
    return Math.max(0,Math.min(n,v));
  }
  function qtyNote(pos){
    var p=productAtPos(pos);if(!p)return '';
    var out=[];
    if(p.q>1)out.push('quantité concernée : '+qtyAt(pos)+' sur '+p.q);
    var n=packSize(p);
    if(n)out.push(upackAt(pos)+' unité(s) sur les '+n+' du pack');
    return out.length?(' ('+out.join(' — ')+')'):'';
  }
  function labelAt(pos){var p=productAtPos(pos);return p?p.n:(S.answers.pfree||'le produit concerné');}
  function imgHtml(p,cls){
    var im=safeImg(p&&p.image);
    return im?('<img class="'+cls+'" src="'+esc2(im)+'" alt="" loading="lazy">'):'<div class="pph"></div>';
  }
  function ansAt(pos){return (S.diagByProd[prodKeyAt(pos)]&&S.diagByProd[prodKeyAt(pos)].answers)||{};}
  function skuOf(p){return (p&&p.s)?(''+p.s).replace(/^REF\s+/i,'').trim():'';}

  function familleFrom(s){
    s=(s||'').toLowerCase();if(!s)return null;
    if(/variateur|contr[oô]leur|t[eé]l[eé]commande|r[eé]cepteur|dimmer|remote/.test(s))return 'telecommande';
    if(/transfo|driver|alimentation/.test(s))return 'transfo';
    if(/ampoule/.test(s))return 'ampoule';
    if(/ruban|strip|bandeau|guirlande|flexible/.test(s))return 'ruban';
    if(/r[eé]glette|tube|n[eé]on/.test(s))return 'reglette';
    if(/spot|encastr|downlight/.test(s))return 'spot';
    if(/projecteur|floodlight/.test(s))return 'projecteur';
    if(/dalle|panneau|plafonnier|hublot|applique|suspension/.test(s))return 'plafonnier';
    if(/connect|smart|wifi/.test(s))return 'connecte';
    return null;
  }
  function prodText(p){return (((p&&p.n)||'')+' '+((p&&p.variant)||'')).toLowerCase();}
  function famForPos(pos){
    var p=productAtPos(pos);
    if(p){
      if(/profil[ée]|connecteur|d[ée]tecteur|goulotte|\bclip\b|\bembout\b/.test(prodText(p)))return null;
      var sp=p.specs||{};
      return familleFrom(sp.default_collection_handle)||familleFrom(prodText(p))||familleFrom(sp.type_de_produit)||null;
    }
    return familleFrom(S.answers.pfree||'');
  }
  detectFamille=function(){return famForPos(0);};

  /* ============================================================
     8bis. DOCUMENTATION PRODUIT : notice PDF, tutoriel video, fiche, guides
     Les metafields Silumen utilises :
       custom.notice_installation  -> URL du PDF de notice
       custom.guide_dinstallation  -> URL du tutoriel video (YouTube)
       custom.fiche_technique_pdf  -> URL de la fiche technique
       custom.maillage_guide_titre_N / _url_N -> guides editos
     Si le lookup ne les renvoie pas, on retombe sur la videotheque par famille.
     ============================================================ */
  /* SILUMEN : aucune videotheque a ce jour. Les deux tutoriels connus sont ceux
     de Silamp et ne doivent PAS etre servis ici — un client Silumen renvoye vers
     une video de marque Silamp, c'est une erreur visible.
     Table volontairement vide : le repli par famille est donc inactif, seule la
     video portee par le metafield custom.guide_dinstallation s'affichera, le
     jour ou ce metafield sera renseigne. */
  var VIDEOS={};
  function ytId(u){
    if(!u)return '';
    var m=/(?:youtu\.be\/|[?&]v=|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/.exec(''+u);
    return m?m[1]:'';
  }
  function resFor(pos){
    var p=productAtPos(pos),sp=(p&&p.specs)||{},fam=famForPos(pos);
    var ext=S.res[prodKeyAt(pos)]||S.res.free||{};
    var r={
      notice:sp.notice_installation||sp.notice||ext.notice||'',
      fiche:sp.fiche_technique_pdf||ext.fiche||'',
      video:ytId(sp.guide_dinstallation||ext.video||''),
      videoT:'',videoD:'',guides:[]
    };
    for(var i=1;i<=3;i++){
      var t=sp['maillage_guide_titre_'+i],u=sp['maillage_guide_url_'+i];
      if(t&&u)r.guides.push({t:t,u:u});
    }
    if(!r.guides.length&&ext.guides&&ext.guides.length)r.guides=ext.guides.slice(0,3);
    var lib=(fam&&VIDEOS[fam])?VIDEOS[fam]:null;
    if(!r.video&&lib)r.video=lib.id;
    if(r.video&&lib&&r.video===lib.id){r.videoT=lib.t;r.videoD=lib.d;}
    if(r.video&&!r.videoT){r.videoT='Tutoriel vidéo Silumen';r.videoD='Le branchement pas à pas, en images.';}
    return r;
  }
  function resHtml(pos,titre,intro){
    var r=resFor(pos);
    if(!r.notice&&!r.video&&!r.fiche&&!r.guides.length)return '';
    r.notice=safeUrl(r.notice);r.fiche=safeUrl(r.fiche);
    r.guides=(r.guides||[]).filter(function(g){g.u=safeUrl(g.u);return !!g.u;});
    var h='<div class="stat"><h4>'+esc2(titre||'La documentation de votre produit')+'</h4>'
      +'<p>'+esc2(intro||"La grande majorité des pannes signalées sont des problèmes de branchement. Deux minutes ici peuvent vous éviter un retour.")+'</p>'
      +'<div class="reslist">';
    if(r.video){
      h+='<div class="yt" data-yt="'+esc2(r.video)+'">'
        +'<div class="ytthumb"><img src="https://i.ytimg.com/vi/'+esc2(r.video)+'/hqdefault.jpg" alt="" loading="lazy"><span class="play">&#9654;</span></div>'
        +'<div><div class="n">'+esc2(r.videoT)+'</div><div class="p">'+esc2(r.videoD)+'</div></div></div>';
    }
    if(r.notice)h+='<a class="resl" href="'+esc2(r.notice)+'" target="_blank" rel="noopener">📄 <span>Notice d\'installation <span class="rsub">— le PDF livré avec votre produit</span></span></a>';
    if(r.fiche)h+='<a class="resl" href="'+esc2(r.fiche)+'" target="_blank" rel="noopener">📐 <span>Fiche technique <span class="rsub">— caractéristiques et schémas de câblage</span></span></a>';
    r.guides.forEach(function(g){h+='<a class="resl" href="'+esc2(g.u)+'" target="_blank" rel="noopener">📘 <span>'+esc2(g.t)+'</span></a>';});
    h+='</div></div>';
    return h;
  }
  /* La condition d'arret testait le CONTENU de la reponse (notice, fiche ou
     guide non vide). Sur un catalogue ou ces metafields ne sont pas renseignes,
     elle n'est jamais vraie : chaque affichage relance l'appel et l'ecran boucle.
     On memorise donc que la ressource a ete DEMANDEE, pas qu'elle a donne
     quelque chose : une ressource absente est une reponse, pas un echec. */
  function loadRes(pos,cb){
    var key=prodKeyAt(pos);
    S._resAsked=S._resAsked||{};
    if(S._resAsked[key]){cb&&cb();return;}
    S._resAsked[key]=1;
    var p=productAtPos(pos);
    askIA({kind:'resources',sku:p?skuOf(p):'',product:labelAt(pos),
      handle:(p&&p.handle)||'',famille:famForPos(pos)||''},function(d){
      if(!d)return cb&&cb();
      S.res[key]={notice:d.notice||'',fiche:d.fiche||'',video:d.video||'',guides:d.guides||[]};
      cb&&cb();
    },function(){cb&&cb();});
  }
  function bindRes(){
    app.querySelectorAll('.yt').forEach(function(el){
      clickable(el,function(){
        var id=el.getAttribute('data-yt');if(!id)return;
        var box=document.createElement('div');
        box.className='ytframe';
        box.innerHTML='<iframe src="https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0" title="Tutoriel Silumen" allow="accelerometer; autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        if(el.parentNode)el.parentNode.replaceChild(box,el);
        doAction('video_vue',{video:id,famille:famForPos(0)||'',sku:(productAtPos(0)?skuOf(productAtPos(0)):'')},function(){});
      });
    });
  }
  /* le piege n°1 sur les tubes T8 : le sens du tube quand l'alimentation est d'un seul cote */
  function estT8(pos){
    var p=productAtPos(pos),sp=(p&&p.specs)||{};
    var t=(prodText(p)||'')+' '+((sp.type_de_tubes_neons||'')+'').toLowerCase()+' '+((S.answers.pfree||'').toLowerCase());
    return /\bt8\b|\bt5\b|tube|n[ée]on|r[ée]glette/.test(t);
  }
  function t8Html(pos){
    if(famForPos(pos)!=='reglette'&&!estT8(pos))return '';
    return '<div class="stat warn"><h4>Le piège n°1 sur les tubes T8 : le sens du tube</h4>'
      +'<p>Sur une réglette alimentée d\'un seul côté, seules les broches de ce côté-là reçoivent le courant. '
      +'Monté à l\'envers, un tube parfaitement neuf ne s\'allume pas — et rien ne le distingue d\'un tube mort. '
      +'L\'indication est imprimée sur le tube, près des broches : elle dit quel côté doit aller côté alimentation.</p>'
      +'<p><b>À vérifier :</b> coupez le courant, sortez le tube, repère l\'indication, remontez-le en le retournant, remettez le courant. '
      +'Vérifiez au passage que le starter d\'origine a bien été retiré, ou remplacé par le starter fourni.</p>'
      +'<p>Le tutoriel vidéo ci-dessous le montre en images.</p></div>';
  }

  /* ============================================================
     9. REGLES DE DIAGNOSTIC (deterministe, secours de l'IA)
     ============================================================ */
  function has(s,w){return s.indexOf(w)>=0;}
  function safetyDiag(a){
    var s=((a&&a.sympt)||'').toLowerCase()+' '+((a&&a.desc)||'').toLowerCase();
    if(/disjonct|court[- ]circuit|fait sauter|fum[ée]e?|br[ûu]l|odeur|feu|incendie|电/.test(s)){
      S.flags.securite=true;
      return {cause:"Un déclenchement du disjoncteur, une odeur, de la fumée ou une trace de brûlé signale un défaut électrique.",steps:["Par sécurité, débranche le produit et ne le rebranche pas."],escalate:true};
    }
    return null;
  }
  function matchRule(fam,a){
    var s=(a.sympt||'').toLowerCase();
    if(!fam||!s)return null;
    var sd=safetyDiag(a);if(sd)return sd;
    var R=null;
    if(fam==='ruban'){
      if(has(s,"s'allume pas")) R={cause:"Le plus souvent : alimentation absente/insuffisante ou polarité + / − inversée.",steps:["Coupez le courant 10 s puis rétablis.","Vérifiez que le transfo est alimenté et la polarité respectée.","En 12/24V, vérifiez que la puissance du transfo ≥ la conso totale du ruban.","Branchez le ruban directement au transfo, sans variateur ni rallonge."]};
      else if(has(s,'portion')) R={cause:"Coupure à un point de coupe ou faux-contact sur un connecteur.",steps:["Vérifiez les connecteurs et les soudures à la zone éteinte.","Assurez-vous d'avoir coupé uniquement aux marques ciseaux prévues."]};
      else if(has(s,'bout')||has(s,'intensit')) R={cause:"Chute de tension : longueur trop grande alimentée d'un seul côté.",steps:["Alimentez le ruban aux deux extrémités, ou ajoutez une alimentation intermédiaire.","Vérifiez la section des fils d'alimentation."]};
      else if(has(s,'scintille')||has(s,'clignote')) R={cause:"Alimentation sous-dimensionnée ou variateur incompatible.",steps:["Retirez le variateur et teste en alim directe.","Vérifiez que le transfo couvre la conso avec ~20 % de marge."]};
      else if(has(s,'couleur')||has(s,'rgb')) R={cause:"Câblage RGB inversé ou contrôleur désynchronisé.",steps:["Vérifiez l'ordre des fils V+/R/G/B.","Coupez puis rétablis le courant du contrôleur pour re-synchroniser."]};
      else if(has(s,'chauffe')) R={cause:"Ruban alimenté enroulé, ou puissance/m élevée sans dissipation.",steps:["Déroulez entièrement le ruban : ne jamais l'alimenter en bobine.","Colle-le sur un profilé alu pour dissiper la chaleur."]};
    }
    else if(fam==='transfo'){
      if(has(s,'aucune')||has(s,'rien')||has(s,"s'allume pas")) R={cause:"Le plus souvent le transfo est hors service (à remplacer) ; parfois une simple mise en sécurité.",steps:["Débranchez la charge et observe le transfo à vide.","Coupez 30 s puis rétablis (reset) ; s'il ne repart pas, il est à remplacer."],escalate:true};
      else if(has(s,'faible')||has(s,'basse')) R={cause:"Surcharge : conso proche ou au-dessus de la puissance nominale.",steps:["Vérifiez que la conso totale ≤ 80 % de la puissance du transfo.","Testez avec une charge réduite."]};
      else if(has(s,'chauffe')) R={cause:"Surcharge ou ventilation insuffisante.",steps:["Réduisez la charge sous 80 % de la puissance.","Ne l'enferme pas, assure une ventilation."]};
      else if(has(s,'coupe')) R={cause:"Protection thermique qui se déclenche (surcharge).",steps:["Réduisez la charge et améliore la ventilation."]};
      else if(has(s,'claque')||has(s,'gr')||has(s,'disjonct')) R={cause:"Un grésillement, un claquement ou un déclenchement du disjoncteur peut indiquer un défaut interne.",steps:["Par sécurité, débranche-le et ne le rebranche pas."],escalate:true};
    }
    else if(fam==='ampoule'){
      if(has(s,"s'allume pas")) R={cause:"Mauvais contact, ou ampoule non-dimmable sur variateur.",steps:["Testez l'ampoule sur un autre luminaire / une autre prise.","Si elle est sur un variateur, retire-le (sauf modèle dimmable)."]};
      else if(has(s,'scintille')||has(s,'papillote')||has(s,'gr')) R={cause:"Variateur non compatible LED, ou interrupteur à voyant lumineux.",steps:["Retirez le variateur ou passe sur un dimmer compatible LED.","Un interrupteur avec voyant lumineux provoque souvent ce scintillement."]};
      else if(has(s,'fant')||has(s,'faiblement')) R={cause:"Interrupteur à voyant, ou coupure sur le neutre au lieu de la phase.",steps:["Retirez le voyant de l'interrupteur.","Vérifiez que l'interrupteur coupe bien la phase."]};
      else if(has(s,'faible')) R={cause:"Contacts oxydés ou culot mal enfoncé.",steps:["Vérifiez et nettoie les contacts, puis testez ailleurs."]};
      else if(has(s,'dur')) R={cause:"Luminaire fermé / encastré : la chaleur réduit la durée de vie.",steps:["Vérifiez l'aération : une ampoule enfermée chauffe et vieillit vite."]};
    }
    else if(fam==='spot'){
      if(has(s,'un spot')) R={cause:"Faux-contact ou spot défectueux isolé dans la série.",steps:["Permutez le spot en panne avec un autre pour l'isoler.","Vérifiez ses connecteurs."]};
      else if(has(s,"s'allume pas")) R={cause:"Driver ou branchement.",steps:["Vérifiez le driver et le branchement.","Testez un spot seul."]};
      else if(has(s,'scintille')||has(s,'clignote')) R={cause:"Variateur ou driver incompatible.",steps:["Retirez le variateur et vérifie la compatibilité du driver."]};
      else if(has(s,'chauffe')) R={cause:"Encastrement sans aération.",steps:["Vérifiez l'aération autour du spot."]};
    }
    else if(fam==='plafonnier'){
      if(has(s,'commande')||has(s,'répond plus')) R={cause:"Pile ou synchro de la télécommande.",steps:["Changez la pile.","Coupez le courant 10 s puis appui long sur ON pour re-synchroniser."]};
      else if(has(s,"s'allume pas")) R={cause:"Alimentation / driver.",steps:["Coupez puis rétablis le courant.","Vérifiez l'alim / driver."]};
      else if(has(s,'scintille')||has(s,'clignote')||has(s,'papillote')) R={cause:"Variateur incompatible.",steps:["Retirez le variateur si présent."]};
      else if(has(s,'bourdon')) R={cause:"Driver en fin de vie ou variateur incompatible.",steps:["Testez sans variateur ; si le bourdonnement persiste, nous remplaçons."],escalate:true};
    }
    else if(fam==='projecteur'){
      if(has(s,'détecteur')||has(s,'detecteur')) R={cause:"Réglages du détecteur (sensibilité, lux jour/nuit, angle).",steps:["Réglez la sensibilité et la temporisation.","Vérifiez le réglage lux (jour/nuit) et l'angle de détection."]};
      else if(has(s,'éteint')||has(s,'eteint')||has(s,'secondes')) R={cause:"Temporisation courte ou mode test du détecteur.",steps:["Augmentez la temporisation et sors du mode test."]};
      else if(has(s,'bu')||has(s,'infiltr')) R={cause:"Une infiltration d'eau compromet le projecteur.",steps:["Ne l'utilise plus ; il faut le remplacer."],escalate:true};
      else if(has(s,"s'allume pas")||has(s,'clignote')) R={cause:"Alimentation.",steps:["Coupez puis rétablis le courant, vérifiez l'alim."]};
    }
    else if(fam==='telecommande'){
      if(has(s,'ne répond')||has(s,'ne repond')) R={cause:"Pile ou perte d'appairage ; si ça persiste, la télécommande est à remplacer.",steps:["Changez la pile.","Refaites l'appairage : appui long sur ON à proximité du récepteur."],escalate:true};
      else if(has(s,'port')||has(s,'distance')) R={cause:"Portée limitée par les obstacles / l'orientation.",steps:["Rapprochez-vous et évitez les masses métalliques.","En RF, dégage / oriente l'antenne du récepteur."]};
      else if(has(s,'couleur')) R={cause:"Câblage RGB au récepteur.",steps:["Vérifiez l'ordre des fils R/G/B au récepteur."]};
      else if(has(s,'synchro')||has(s,'appair')) R={cause:"Perte d'appairage.",steps:["Coupez le courant du récepteur 10 s, puis appui long sur ON pour ré-appairer."]};
    }
    else if(fam==='reglette'){
      if(/pas vérifié|pas verifie|je ne sais pas/i.test(a.sens||''))
        R={cause:"Sur une réglette alimentée d'un seul côté, un tube monté à l'envers ne s'allume pas : les broches alimentées ne sont pas du bon côté. C'est la cause n°1 des tubes déclarés défectueux.",
           steps:["Coupez le courant, sortez le tube et repérez l'indication imprimée près des broches.","Remonte-le en le retournant, du côté indiqué comme alimenté.","Vérifiez que le starter d'origine a été retiré ou remplacé par celui fourni.","Le tutoriel vidéo ci-dessus montre le montage complet."]};
      else if(has(s,'série')||has(s,'serie')||has(s,'une réglette')||has(s,'une reglette')) R={cause:"Faux-contact ou réglette défectueuse dans la série.",steps:["Permutez la réglette éteinte pour l'isoler.","Vérifiez les connecteurs de liaison."]};
      else if(has(s,"s'allume pas")) R={cause:"Tube rétrofit : starter non retiré / shunté.",steps:["Vérifiez le retrait ou le shunt du starter selon la notice.","Vérifiez les contacts aux douilles."]};
      else if(has(s,'scintille')||has(s,'clignote')||has(s,'gr')) R={cause:"Starter (rétrofit) ou contacts.",steps:["Vérifiez le starter et les contacts aux douilles."]};
    }
    else if(fam==='connecte'){
      if(has(s,'appair')) R={cause:"Le WiFi 2,4 GHz est requis (pas le 5 GHz).",steps:["Rapprochez l'appareil du routeur.","Placez votre téléphone sur le WiFi 2,4 GHz pendant l'appairage."]};
      else if(has(s,'déconnec')||has(s,'deconnec')) R={cause:"Signal WiFi trop faible.",steps:["Rapprochez du routeur ou ajoute un répéteur 2,4 GHz."]};
      else if(has(s,'ne répond')||has(s,'ne repond')) R={cause:"Appli ou appareil à redémarrer.",steps:["Redémarre l'appareil et l'appli, puis ré-appaire si besoin."]};
      else if(has(s,'jour')) R={cause:"Mise à jour interrompue.",steps:["Reste proche du routeur et ne coupe pas pendant la mise à jour."]};
    }
    return R;
  }

  /* ============================================================
     10. APPEL IA GENERIQUE
     ============================================================ */
  /* Filet global : une session ne peut pas declencher plus de 25 appels IA. */
  var IA_MAX=25;
  function askIA(payload,ok,ko){
    S._iaCount=(S._iaCount||0)+1;
    if(S._iaCount>IA_MAX){try{console.warn('SAV : plafond d\'appels IA atteint');}catch(e){}ko&&ko();return;}
    var k=(payload&&payload.kind)||'';
    var ep=((k==='alt'||k==='resources')&&ALT_ENDPOINT)?ALT_ENDPOINT:DIAG_ENDPOINT;
    if(!ep){ko&&ko();return;}
    var ctrl=('AbortController' in window)?new AbortController():null;
    /* 9 s coupaient AVANT la fin de la generation : un diagnostic prend 10 a 13 s,
       une reponse a une question davantage. Le formulaire abandonnait, affichait
       son repli, et le workflow terminait pour rien — en succes cote n8n, ce qui
       rendait la panne invisible. */
    var timer=setTimeout(function(){if(ctrl)ctrl.abort();},25000);
    fetch(ep,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:ctrl?ctrl.signal:undefined})
      .then(function(r){return r.json();})
      .then(function(d){clearTimeout(timer);ok&&ok(d||{});})
      .catch(function(){clearTimeout(timer);ko&&ko();});
  }
  function doAction(action,extra,cb){
    var p={kind:'action',action:action,order:(S.order&&S.order.id)||'',
      email:(S.contact.email||(S.order&&S.order.email)||'').trim(),
      name:(S.contact.nom||(S.order&&S.order.name)||'').trim()};
    for(var k in extra){if(extra.hasOwnProperty(k))p[k]=extra[k];}
    if(!ACTION_ENDPOINT){cb&&cb(false);return;}
    fetch(ACTION_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(p)})
      .then(function(r){return r.ok;}).then(function(v){cb&&cb(!!v);}).catch(function(){cb&&cb(false);});
  }

  /* ============================================================
     11. ECRANS DE SORTIE SANS TICKET
     ============================================================ */
  /* Tout ecran de fin propose de repartir : un client qui vient de regler un
     sujet en a souvent un second, et sans porte de sortie il repart par mail. */
  function retourHtml(){
    return '<div class="actions" style="justify-content:center;margin-top:26px">'
      +'<button class="btn ghost" id="rehome">← Faire une autre demande</button></div>';
  }
  function bindRetour(){
    var b=SGID('rehome');
    if(!b)return;
    b.onclick=function(){
      reset();
      try{var r=document.querySelector('#sav-root');if(r&&r.scrollIntoView)r.scrollIntoView({block:'start',behavior:'smooth'});}catch(e){}
    };
  }
  function finir(html){
    clearDraft();
    app.innerHTML=html+retourHtml();
    bar.style.width='100%';
    bindRetour();
  }
  function endOk(titre,corps){
    finir('<div class="done"><div class="big">✓</div><h2 class="q">'+titre+'</h2>'
      +'<p class="sub">'+corps+'</p>'
      +'<p class="muted">Aucun dossier n\'a été ouvert. Si la situation évolue, revenez ici : tout repart de votre commande.</p></div>');
  }
  function endAuto(titre,corps){
    finir('<div class="done"><div class="big">✓</div><h2 class="q">'+titre+'</h2>'
      +'<p class="sub">'+corps+'</p></div>');
  }

  /* ============================================================
     12. BRANCHE 1 - SUIVI DE LIVRAISON
     ============================================================ */
  /* Colis remontes par Shippingbo. Tant que l'appel n'a pas repondu, on retombe
     sur l'unique suivi connu de Shopify plutot que de n'afficher rien. */
  function colisList(){
    var f=ful();
    if(f.colis&&f.colis.length)return f.colis;
    if(f.tracking)return [{tracking:f.tracking,carrier:f.carrier||'GLS',url:f.url||'',state:f.status||'',shipped_at:f.shipped_at||'',delivered_at:f.delivered_at||''}];
    return [];
  }
  var ETATS={
    delivered:['Livré','ok'], livre:['Livré','ok'], received:['Livré','ok'],
    in_transit:['En cours d\'acheminement','go'], transit:['En cours d\'acheminement','go'],
    shipped:['Expédié','go'], sent:['Expédié','go'], handed:['Remis au transporteur','go'],
    pending:['En préparation',''], preparing:['En préparation',''], created:['Étiquette créée',''],
    failure:['Incident de livraison',''], returned:['Retourné à l\'expéditeur','']
  };
  function etatColis(v){
    var k=String(v||'').toLowerCase().replace(/[^a-z_]/g,'');
    return ETATS[k]||[v?String(v):'',''];
  }
  function colisHtml(){
    var l=colisList();
    if(!l.length)return '';
    var multi=l.length>1;
    var h='<div class="stat"><h4>'+(multi?('Votre commande a été expédiée en '+l.length+' colis'):'Votre colis')+'</h4>';
    l.forEach(function(c,i){
      var e=etatColis(c.state);
      var u=safeUrl(c.url);
      h+='<div class="colis">'
        +'<span class="n">'+(multi?('Colis '+(i+1)):'Suivi')+'</span>'
        +'<span class="num">'+esc2(c.tracking)+'</span>'
        +'<span>'+esc2(c.carrier||'GLS')+'</span>'
        +(e[0]?'<span class="et '+e[1]+'">'+esc2(e[0])+'</span>':'')
        +(u?'<a href="'+esc2(u)+'" target="_blank" rel="noopener">Suivre ce colis →</a>':'')
        +'</div>';
    });
    if(multi){
      h+='<p>Les colis d\'une même commande voyagent séparément et peuvent arriver à des jours différents. '
        +'Tant qu\'un seul est encore en route, il est normal de ne pas avoir tout reçu.</p>';
    }
    return h+'</div>';
  }
  function chargerColis(){
    if(!SUIVI_ENDPOINT||S._colisFait)return;
    var id=(S.order&&S.order.id)||'';
    if(!id&&!(S.contact.email||(S.order&&S.order.email)))return;
    S._colisFait=true;
    var ctrl=('AbortController' in window)?new AbortController():null;
    var t=setTimeout(function(){if(ctrl)ctrl.abort();},12000);
    fetch(SUIVI_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({order:id,email:(S.contact.email||(S.order&&S.order.email)||'')}),
      signal:ctrl?ctrl.signal:undefined})
      .then(function(r){return r.json();})
      .then(function(d){
        clearTimeout(t);
        if(!d||!d.found||!d.colis||!d.colis.length)return;
        if(!S.order)return;
        S.order.fulfillment=S.order.fulfillment||{};
        S.order.fulfillment.colis=d.colis;
        if(!S.order.fulfillment.tracking&&d.colis[0])S.order.fulfillment.tracking=d.colis[0].tracking;
        if(!S.order.fulfillment.carrier&&d.colis[0])S.order.fulfillment.carrier=d.colis[0].carrier;
        var livres=0;
        d.colis.forEach(function(c){if(/deliver|livre|received/i.test(c.state||''))livres++;});
        if(livres&&livres===d.colis.length)S.order.fulfillment.status='delivered';
        else if(d.colis.length)S.order.fulfillment.status=S.order.fulfillment.status||'in_transit';
        if(flow()[S.step]==='suivi')render();
      })
      .catch(function(){clearTimeout(t);});
  }
  /* Le delai annonce doit venir du mode de livraison REELLEMENT PAYE. Le libelle
     Shopify le contient presque toujours (« ... (5 a 10 jours ouvres) »), et c'est
     la seule source fiable : Liquid ne transmet pas de delai structure.
     Annoncer J+1 a un client parti en economique, c'est promettre ce qu'on ne
     tiendra pas et transformer une livraison normale en retard percu. */
  function delaiTransport(){
    var sh=ship();
    var t=String(sh.label||'').toLowerCase().replace(/\u00a0/g,' ');
    var m=t.match(/(\d+)\s*(?:à|a|-|\/|et)\s*(\d+)\s*jours?/);
    if(m)return {min:+m[1],max:+m[2],source:'libelle'};
    m=t.match(/(\d+)\s*jours?\s*ouvr/);
    if(m)return {min:+m[1],max:+m[1],source:'libelle'};
    if(/24\s*[-\/aà]*\s*48\s*h|\b48\s*h|\b24\s*h|express|rapide/.test(t))return {min:1,max:2,source:'libelle'};
    if(/relais|point retrait|pickup/.test(t))return {min:2,max:4,source:'libelle'};
    var pn=parseInt(sh.promise_min,10),pm=parseInt(sh.promise_max,10);
    if(!isNaN(pm))return {min:isNaN(pn)?Math.max(1,pm-1):pn,max:pm,source:'lookup'};
    return {min:2,max:5,source:'defaut'};
  }
  var PREPA_JOURS=1;   /* notre delai de preparation en entrepot, en jours ouvres */
  function fenetreLivraison(){
    var base=(S.order&&(S.order.date||S.order.created_at))||null;
    if(!base)return null;
    var d=delaiTransport();
    return {
      min:addOuvres(PREPA_JOURS+d.min,base),
      max:addOuvres(PREPA_JOURS+d.max,base),
      d:d
    };
  }
  function fenetreHtml(){
    var f=fenetreLivraison();
    if(!f)return '';
    var lab=ship().label?esc2(ship().label):'';
    var meme=(f.d.min===f.d.max);
    return '<p>Vous avez choisi '+(lab?('<b>'+lab+'</b>')+' : ':'ce mode de livraison : ')
      +'comptez '+f.d.min+(meme?'':(' à '+f.d.max))+' jour'+(f.d.max>1?'s':'')+' ouvré'+(f.d.max>1?'s':'')
      +' de transport après l\'expédition. <b>Livraison estimée '
      +(meme?('le '+esc2(frLong(f.max))):('entre le '+esc2(frLong(f.min))+' et le '+esc2(frLong(f.max))))
      +'.</b></p>';
  }
  function suiviEtat(){
    var f=ful(),sh=ship();
    var st=(f.status||'').toLowerCase();
    var dt=delaiTransport();
    var promis=PREPA_JOURS+dt.max;
    var jCmd=daysBetween(S.order&&S.order.date);
    var jScan=f.last_event&&f.last_event.date?daysBetween(f.last_event.date):null;
    var jShip=f.shipped_at?daysBetween(f.shipped_at):null;
    var retard=(jCmd!=null&&jCmd>promis);
    var out={statut:st,promis:promis,jCmd:jCmd,jScan:jScan,jShip:jShip,retard:retard,express:!!sh.express};
    if(st==='delivered'){out.cas='livre';return out;}
    /* « préparation anormalement longue » se juge sur le délai du mode payé,
       pas sur une valeur fixe : 6 jours sont normaux en économique, pas en express. */
    if(!f.tracking&&!f.shipped_at){out.cas=(jCmd!=null&&jCmd>promis)?'prepa_long':'prepa';return out;}
    if(jScan==null&&jShip!=null&&jShip>3){out.cas='jamais_pris';return out;}
    if(jScan!=null&&jScan>=2){out.cas='bloque';return out;}
    if(retard){out.cas='retard';return out;}
    out.cas='route';return out;
  }
  VIEWS.suivi=function(){
    var f=ful(),sh=ship(),e=suiviEtat();
    var h='<div class="step-label">Étape 3 · Suivi</div><h2 class="q">Où en est votre commande</h2>';

    if(!orderMode()){
      h+='<div class="stat warn"><h4>Nous n\'avons pas retrouvé votre commande</h4>'
        +'<p>Sans elle, nous ne pouvons pas consulter le suivi. Décrivez votre situation à l\'étape suivante : un conseiller la retrouvera avec votre nom et votre adresse, et vous répondra avant '+engagement(1)+'.</p></div>'
        +'<div class="actions"><button class="btn primary" id="toct">Continuer →</button></div>';
      return h;
    }

    var trk=f.tracking?('<span>Suivi '+esc2(f.carrier||'GLS')+'</span> <b>'+esc2(f.tracking)+'</b>'):'';
    var last=f.last_event&&f.last_event.label?('<span>Dernier événement</span> <b>'+esc2(f.last_event.label)+(f.last_event.date?' — '+esc2(frLong(f.last_event.date)):'')+'</b>'):'';
    var eta=f.eta?('<span>Livraison estimée</span> <b>'+esc2(frLong(f.eta))+'</b>'):'';
    var mode=sh.label?('<span>Livraison choisie</span> <b>'+esc2(sh.label)+'</b>'):'';

    if(e.cas==='livre'){
      h+='<div class="stat warn"><h4>'+esc2(f.carrier||'Le transporteur')+' indique avoir livré votre colis'
        +(f.delivered_at?' le '+esc2(frLong(f.delivered_at)):'')+'</h4>'
        +'<p>Si vous ne l\'avez pas reçu, signalez-le ici : nous vous croyons, et un conseiller prend votre dossier en charge.</p>'
        +'<div class="kv">'+trk+last+'</div></div>'
        +'<div class="actions"><button class="btn primary" id="tononrecu">Je ne l\'ai pas reçu →</button>'
        +'<button class="btn ghost" id="okfin">Tout est bon, merci</button></div>';
      return h;
    }
    if(e.cas==='prepa'||e.cas==='prepa_long'){
      var base=(S.order&&S.order.date)||null;
      var dep=frLong(addOuvres(PREPA_JOURS,base));
      h+='<div class="stat '+(e.cas==='prepa'?'ok':'warn')+'"><h4>Votre commande est en préparation dans notre entrepôt</h4>'
        +'<p>Expédition prévue au plus tard le '+esc2(dep)+'. Vous recevrez le numéro de suivi par mail et par SMS dès l\'enlèvement du colis.</p>'
        +fenetreHtml()
        +'</div>';
      if(e.cas==='prepa_long'){
        h+='<div class="tip"><b>Au-delà du délai annoncé —</b> si un article de votre commande est en rupture, nous vous l\'indiquons avec une date. Demandez-le ci-dessous et nous vous répondons avant '+engagement(1)+'.</div>';
      }
    }
    else if(e.cas==='route'){
      h+='<div class="stat ok"><h4>Votre colis est en route</h4>'
        +'<div class="kv">'+trk+last+eta+mode+'</div>'
        +(f.eta?'':fenetreHtml())
        +'<p><b>Une précision utile.</b> Le premier scan signifie que l\'étiquette a été créée, pas toujours que le colis est déjà physiquement chez le transporteur. En période de forte activité, il peut s\'écouler 24 à 48 heures entre les deux. Si le suivi ne bouge plus au-delà de 48 heures, reviens ici : nous lançons une réclamation.</p></div>';
    }
    else if(e.cas==='retard'){
      h+='<div class="stat warn"><h4>Votre colis a dépassé le délai annoncé</h4>'
        +'<div class="kv">'+trk+last+eta+mode+'</div>'
        +'<p>Il circule toujours : le dernier scan date de moins de 48 heures. Nouvelle estimation ci-dessus.</p></div>';
      if(e.express){
        h+='<div class="stat ok"><h4>Vous aviez opté pour une livraison accélérée</h4>'
          +'<p>Le délai express n\'a pas été tenu. Le remboursement des frais de port accélérés est examiné avec votre dossier : vous n\'avez aucune démarche à effectuer, un conseiller revient vers vous avant le '+engagement(1)+'.</p></div>';
        S.flags.express_refund=true;
      }
    }
    else { /* bloque | jamais_pris */
      var titre=(e.cas==='bloque')?'Votre colis n\'a pas évolué depuis '+(e.jScan||2)+' jours. Ce n\'est pas normal, nous prenons la main.'
        :'Votre colis n\'a jamais été scanné par le transporteur. Nous prenons la main.';
      h+='<div class="stat bad"><h4>'+esc2(titre)+'</h4>'
        +'<div class="kv">'+trk+last+mode+'</div>'
        +'<p>La réclamation auprès de '+esc2(f.carrier||'GLS')+', c\'est notre démarche : vous n\'avez rien à faire de ce côté, et elle ne retardera pas la solution que nous vous proposons.</p></div>'
        +'<h2 class="q" style="font-size:20px;margin-top:26px">Indiquez-nous simplement ce que vous préférez</h2>'
        +decHtml([
          ['attendre','J\'attends encore','Nous relançons le transporteur et vous tenons informé. Sans mouvement de sa part, nous vous proposerons une réexpédition ou un remboursement.'],
          ['reexpedition','Réexpédiez-moi la commande','Nous préparons une nouvelle expédition. Le premier colis est notre affaire.'],
          ['remboursement','Remboursez-moi','Nous engageons le remboursement de votre commande.']
        ])
        +'<div class="err" id="e_dec">Sélectionnez une option pour que nous puissions agir.</div>';
    }

    h+=colisHtml();

    /* coordonnees GLS - le transporteur notifie sur ces coordonnees */
    h+='<div class="stat"><h4>Vérifiez vos coordonnées de livraison</h4>'
      +'<p>'+esc2(f.carrier||'GLS')+' envoie le suivi, l\'avis de passage et le créneau de livraison sur ces coordonnées. Une erreur ici, et vous ne recevez plus rien.</p>'
      +'<label class="f">Email</label><input type="email" id="s_mail" value="'+esc2(S.contact.email||(S.order&&S.order.email)||'')+'" placeholder="vous@email.fr">'
      +'<label class="f">Téléphone mobile <span class="hint">(indispensable pour le SMS de livraison)</span></label>'
      +'<input type="tel" id="s_tel" value="'+esc2(S.contact.tel||(S.order&&S.order.phone)||'')+'" placeholder="06 12 34 56 78">'
      +'<div style="margin-top:12px"><button class="btn ghost" id="s_upd">Mettre à jour mes coordonnées</button></div></div>';

    if(e.cas==='route'||e.cas==='retard'||e.cas==='prepa'||e.cas==='prepa_long'){
      h+='<div class="actions">'
        +'<button class="btn ghost" id="okfin">C\'est clair, merci</button>'
        +'<button class="btn primary" id="toct">Il y a un problème — parler au SAV →</button></div>';
    }else{
      h+='<div class="actions"><button class="btn primary" id="toct">Valider mon choix →</button></div>';
    }
    return h;
  };
  function setupSuivi(){
    chargerColis();
    var e=suiviEtat();
    bindDec();
    var up=SGID('s_upd');
    if(up)up.onclick=function(){
      var m=SGID('s_mail'),t=SGID('s_tel');
      S.contact.email=(m?m.value:'').trim();S.contact.tel=(t?t.value:'').trim();
      up.disabled=true;up.textContent='Enregistrement…';
      doAction('maj_coordonnees',{new_email:S.contact.email,new_phone:S.contact.tel},function(ok){
        if(ok){up.textContent='Coordonnées enregistrées ✓';}
        else{S.flags.maj_coordonnees=true;up.textContent='À transmettre au conseiller';}
      });
    };
    var ok=SGID('okfin');
    if(ok)ok.onclick=function(){
      S.sortie='S1';
      var nb=colisList().length;
      endOk('Parfait, tout est clair.',(nb>1?('Vos '+nb+' colis sont suivis.'):'Votre colis est suivi.')+' Vous recevrez une notification à chaque étape.');
    };
    var nr=SGID('tononrecu');
    if(nr)nr.onclick=function(){S.motif='nonrecu';S.step=2;render();};
    var go=SGID('toct');
    if(go)go.onclick=function(){
      if((e.cas==='bloque'||e.cas==='jamais_pris')&&!S.decision){var er=SGID('e_dec');if(er)er.style.display='block';return;}
      S.sortie='S3';S.escal=S.escal||('suivi : '+e.cas);
      S.step++;render();
    };
  }

  /* ============================================================
     13. BRANCHE 2 - COLIS LIVRE MAIS NON RECU
     ============================================================ */
  function attestNonRecu(){
    var f=ful();
    return "J'atteste sur l'honneur ne pas avoir reçu le colis n° "+((f.tracking)||'(numéro de suivi)')
      +" relatif à la commande "+((S.order&&S.order.id)||'(commande)')
      +(f.delivered_at?", malgré la mention de livraison du transporteur en date du "+frDate(f.delivered_at):"")
      +". Je sais que cette déclaration sera transmise au transporteur dans le cadre d'une réclamation, et qu'une déclaration inexacte destinée à obtenir un remboursement ou un renvoi indu est susceptible d'engager ma responsabilité.";
  }
  VIEWS.nonrecu=function(){
    var f=ful();
    var h='<div class="step-label">Étape 3 · Colis non reçu</div>';
    if(f.delivered_at||f.tracking){
      h+='<h2 class="q">'+esc2(f.carrier||'GLS')+' indique avoir livré votre colis'+(f.delivered_at?' le '+esc2(frLong(f.delivered_at)):'')+'</h2>'
        +'<p class="sub">Vous nous indiquez que ce n\'est pas le cas : <b>nous vous croyons et nous agissons</b>.</p>';
    }else{
      h+='<h2 class="q">Votre colis est annoncé livré et vous ne l\'avez pas reçu</h2>'
        +'<p class="sub">Nous vous croyons et nous agissons. Trois vérifications rapides au préalable.</p>';
    }
    h+='<div class="stat"><h4>Trois vérifications qui résolvent souvent la situation</h4>'
      +ckHtml('v1','J\'ai vérifié auprès de mes voisins')
      +ckHtml('v2','J\'ai vérifié dans mon garage, sous l\'abri, derrière le portail')
      +ckHtml('v3','Personne d\'autre au foyer n\'a réceptionné le colis')
      +'</div>'
      +'<div class="attest"><label class="ck"><input type="checkbox" id="att" '+(S.attest?'checked':'')+'>'
      +'<span><b>Attestation sur l\'honneur</b></span></label>'
      +'<p class="txt">'+esc2(attestNonRecu())+'</p></div>'
      +'<div class="stat ok"><h4>Ce que nous faisons</h4>'
      +'<p>Nous préparons une nouvelle expédition de votre commande. Vous recevrez le numéro de suivi du nouveau colis dès son départ.</p></div>'
      +'<div class="tip">La réclamation auprès du transporteur est notre démarche : elle ne conditionne jamais votre renvoi et ne le retarde pas.</div>'
      +'<p class="muted">Cette solution ne vous convient pas ? '
      +'<button class="link" id="autresol" type="button">Dites-le nous</button> — un conseiller reprend votre dossier avant le '+engagement(1)+'.</p>'
      +'<div class="err" id="e_nr">Cochez les trois vérifications et l\'attestation avant de continuer.</div>'
      +navHTML('Envoyer ma demande');
    return h;
  };

  /* ============================================================
     14. BRANCHE 3 - ERREUR DE PREPARATION / ARTICLE MANQUANT
     ============================================================ */
  var SUBM=[['manquant','Manquant'],['qte','Quantité insuffisante'],['mauvais','Ce n\'est pas le bon produit']];
  function attestPrepa(){
    return "J'atteste sur l'honneur que les éléments déclarés ci-dessus sont exacts et que je n'ai pas reçu les articles signalés comme manquants dans la commande "
      +((S.order&&S.order.id)||'(commande)')
      +". Je sais que cette déclaration fonde la décision prise en ma faveur et qu'une déclaration inexacte destinée à obtenir un envoi ou un remboursement indu est susceptible d'engager ma responsabilité.";
  }
  VIEWS.prepa=function(){
    var h='<div class="step-label">Étape 3 · Erreur de préparation</div>';
    if(!orderMode()||sansDetail()){
      h+='<h2 class="q">Qu\'est-ce qui manque ou ne correspond pas ?</h2>'
        +'<p class="sub">Sans numéro de commande, décris-le du mieux possible.</p>'
        +'<label class="f">Produit concerné <span class="req">*</span></label>'
        +'<input type="text" id="pfree" placeholder="ex : Ruban LED RGB 24V" value="'+esc2(S.answers.pfree||'')+'">'
        +field({id:'desc',l:'Ce qui manque, ou ce que vous avez reçu à la place',type:'textarea',ph:'ex : il manque le kit de fixation et la notice',req:true})
        +'<div class="err" id="e_prepa">Complétez les champs obligatoires.</div>'+navHTML();
      return h;
    }
    h+='<h2 class="q">Voici ce que nous avons expédié. Cochez ce qui pose problème.</h2>'
      +'<p class="sub">Vous n\'avez rien à décrire : cochez la ligne et le type de problème. La référence exacte est transmise avec votre dossier, à nous et à notre logistique.</p>';
    (S.order.products||[]).forEach(function(p,i){
      var L=S.lines[i]||{};
      h+='<div class="line '+(L.on?'on':'')+'" data-li="'+i+'">'
        +'<label class="ck" style="padding:0"><input type="checkbox" class="lchk" data-li="'+i+'" '+(L.on?'checked':'')+'>'
        +'<span class="line-h">'+imgHtml(p,'')+'<span><span class="n">'+esc2(p.n)+'</span>'
        +'<span class="s">'+esc2(skuOf(p))+' · Qté '+esc2(p.q)+(p.price?' · '+esc2(money(p.price)):'')+'</span></span></span></label>';
      if(L.on){
        h+='<div class="subm">'+SUBM.map(function(s){
          return '<button type="button" class="sb '+(L.type===s[0]?'on':'')+'" data-li="'+i+'" data-t="'+s[0]+'">'+s[1]+'</button>';
        }).join('')+'</div>';
        var N=packSize(p),mx=N||p.q;
        if(L.type==='qte'&&mx>1){
          h+='<div class="qtywrap" style="margin-left:58px">'
            +'<span>'+(N?('Unités réellement reçues sur les '+N+' du pack :'):'Quantité réellement reçue :')+'</span>'
            +'<input type="number" class="lqte" data-li="'+i+'" min="0" max="'+mx+'" value="'+(L.qte!=null?L.qte:'')+'"><span>/ '+mx+'</span></div>';
        }
      }
      h+='</div>';
    });
    h+=field({id:'desc',l:'Vous avez reçu un produit que vous n\'aviez pas commandé ? Décrivez-le',type:'textarea',ph:'ex : un spot 5W à la place du ruban, référence SP-5W-XX sur l\'étiquette',req:false})
      +'<div class="attest"><label class="ck"><input type="checkbox" id="att" '+(S.attest?'checked':'')+'>'
      +'<span><b>Attestation sur l\'honneur</b></span></label>'
      +'<p class="txt">'+esc2(attestPrepa())+'</p></div>'
      +'<div class="err" id="e_prepa">Cochez au moins une ligne avec son type de problème, ainsi que l\'attestation.</div>'
      +navHTML('Continuer — photos');
    return h;
  };
  function setupPrepa(){
    if(sansDetail())return;
    app.querySelectorAll('.lchk').forEach(function(c){
      c.onclick=function(ev){ev.stopPropagation();};
      c.onchange=function(){
        var i=+c.dataset.li;
        if(!S.lines[i])S.lines[i]={};
        S.lines[i].on=c.checked?1:0;
        if(!c.checked){S.lines[i].type=null;S.lines[i].qte=null;}
        render();
      };
    });
    app.querySelectorAll('.sb').forEach(function(b){
      b.onclick=function(ev){ev.stopPropagation();var i=+b.dataset.li;S.lines[i]=S.lines[i]||{on:1};S.lines[i].type=b.dataset.t;render();};
    });
    app.querySelectorAll('.lqte').forEach(function(q){
      q.onclick=function(ev){ev.stopPropagation();};
      q.onchange=function(){var i=+q.dataset.li;S.lines[i]=S.lines[i]||{on:1};S.lines[i].qte=q.value;};
    });
  }

  /* ============================================================
     15. BRANCHE 4 - COLIS ABIME
     ============================================================ */
  VIEWS.q_casse=function(){
    var today=new Date().toISOString().slice(0,10);
    var f=ful();
    var pre=(S.answers.recdate||(f.delivered_at?(parseDate(f.delivered_at)||new Date()).toISOString().slice(0,10):''));
    return '<div class="step-label">Étape 4 · Colis abîmé</div><h2 class="q">Votre colis est arrivé abîmé</h2>'
    +'<p class="sub">Deux questions, puis trois photos : c\'est ce qui permet à un conseiller de trancher sans vous écrire trois fois.</p>'
    +'<label class="f" for="f_recdate">Date de réception <span class="req">*</span></label>'
    +'<input type="date" id="f_recdate" max="'+today+'" value="'+esc2(pre)+'">'
    +field({id:'pack',l:'Emballage extérieur visiblement endommagé ?',type:'select',opts:["Oui, carton écrasé / déchiré","Non, emballage intact mais produit cassé"],req:true})
    +field({id:'desc',l:'Décrivez la casse',type:'textarea',ph:'ex : la vitre du plafonnier est fêlée...',req:true})
    +'<div class="tip"><b>À quoi servent vos photos —</b> la photo du carton fermé nous permet de savoir si le dommage vient du transport ou de notre emballage. C\'est ce qui nous permet de corriger le problème à la source, pas seulement de te remplacer le produit.</div>'
    +'<div class="err" id="e_q">Complétez les champs obligatoires.</div>'+navHTML('Continuer — photos');
  };

  /* ============================================================
     16. BRANCHE 5 - PRODUIT DEFECTUEUX (autodiagnostic)
     ============================================================ */
  /* Le detail des lignes n'est transmis que pour les commandes recentes : au-dela,
     la page pesserait trop. Sur une commande ancienne, on demande donc le produit
     plutot que d'afficher une liste vide. */
  function sansDetail(){
    return orderMode()&&(!S.order.products||!S.order.products.length);
  }
  VIEWS.product=function(){
    if(sansDetail()){
      return '<div class="step-label">Étape 3 · Produit concerné</div>'
        +'<h2 class="q">Quel produit de la commande '+esc2(S.order.id)+' est concerné ?</h2>'
        +'<p class="sub">Cette commande est ancienne : son détail n\'est pas chargé automatiquement. '
        +'Indiquez le produit, un conseiller retrouvera la référence exacte.</p>'
        +'<label class="f">Nom ou référence du produit <span class="req">*</span></label>'
        +'<input type="text" id="pfree" placeholder="ex : Ruban LED RGB 24V" value="'+esc2(S.answers.pfree||'')+'">'
        +'<div class="err" id="e_prod">Indiquez le produit concerné.</div>'+navHTML();
    }
    if(!orderMode()){
      return '<div class="step-label">Étape 3 · Produit concerné</div><h2 class="q">Quel produit est concerné ?</h2>'
      +'<p class="sub">Sans numéro de commande, indique le produit du mieux possible.</p>'
      +'<label class="f">Nom ou référence du produit <span class="req">*</span></label>'
      +'<input type="text" id="pfree" placeholder="ex : Ruban LED RGB 24V" value="'+esc2(S.answers.pfree||'')+'">'
      +'<div class="err" id="e_prod">Indiquez le produit concerné.</div>'+navHTML();
    }
    var list=S.order.products.map(function(p,i){
      var sel=(S.selProducts||[]).indexOf(i)>=0;
      var g=garantieDe(p);
      var bdg=g.known?('<span class="badge '+(g.in?'in':'out')+'">'+(g.in?'sous garantie':'hors garantie')+'</span>'):'';
      var qtyHtml='';
      if(sel){
        var N=packSize(p);
        if(p.q>1){
          var cur=S.qty[i]||p.q;
          qtyHtml+='<div class="qtywrap"><span>'+(N?'Nombre de packs concernés :':'Quantité concernée :')+'</span>'
            +'<input type="number" class="qtysel" data-qi="'+i+'" min="1" max="'+p.q+'" value="'+cur+'"><span>/ '+p.q+'</span></div>';
        }
        if(N){
          qtyHtml+='<div class="qtywrap"><span>Unités concernées dans le pack :</span>'
            +'<input type="number" class="upsel" data-ui="'+i+'" min="0" max="'+N+'" value="'+upackAt((S.selProducts||[]).indexOf(i))+'"><span>/ '+N+'</span>'
            +'<span class="hint">Une seule unité peut être concernée dans le pack.</span></div>';
        }
      }
      return '<div class="prod '+(sel?'sel':'')+'" data-i="'+i+'">'+imgHtml(p,'pimg')
        +'<div class="meta"><div class="n">'+esc2(p.n)+bdg+'</div><div class="s">'+esc2(skuOf(p))+' · Qté '+p.q+'</div>'+qtyHtml+'</div>'
        +'<div class="chk">✓</div></div>';
    }).join('');
    return '<div class="step-label">Étape 3 · Produit concerné</div><h2 class="q">Quel(s) article(s) de la commande '+esc2(S.order.id)+' ?</h2>'
      +'<p class="sub">Cochez le ou les produits concernés, et ajustez la quantité si nécessaire.</p>'+list
      +'<div class="err" id="e_prod">Sélectionnez au moins un produit.</div>'+navHTML();
  };
  function setupProduct(){
    app.querySelectorAll('.prod').forEach(function(el){
      clickable(el,function(){
        var i=+el.dataset.i;
        if(S.selProducts.indexOf(i)>=0)S.selProducts=S.selProducts.filter(function(x){return x!==i;});
        else S.selProducts.push(i);
        S.famille=null;render();
      });
    });
    app.querySelectorAll('.qtywrap').forEach(function(w){w.onclick=function(e){e.stopPropagation();};});
    app.querySelectorAll('.qtysel').forEach(function(sel){
      var mx=+sel.getAttribute('max')||1;
      sel.onclick=function(e){e.stopPropagation();};
      sel.onchange=function(){var v=parseInt(sel.value,10);if(isNaN(v)||v<1)v=1;if(v>mx)v=mx;sel.value=v;S.qty[+sel.dataset.qi]=v;};
      sel.oninput=function(){var v=parseInt(sel.value,10);if(!isNaN(v)&&v>=1&&v<=mx)S.qty[+sel.dataset.qi]=v;};
    });
    app.querySelectorAll('.upsel').forEach(function(sel){
      var mxu=+sel.getAttribute('max')||1;
      sel.onclick=function(e){e.stopPropagation();};
      sel.onchange=function(){var v=parseInt(sel.value,10);if(isNaN(v)||v<0)v=0;if(v>mxu)v=mxu;sel.value=v;S.upack[+sel.dataset.ui]=v;};
      sel.oninput=function(){var v=parseInt(sel.value,10);if(!isNaN(v)&&v>=0&&v<=mxu)S.upack[+sel.dataset.ui]=v;};
    });
  }

  /* question ajoutee : le sens du tube T8, cause n°1 des "tubes morts" qui ne le sont pas */
  try{
    if(FAMILLES.reglette&&FAMILLES.reglette.q){
      FAMILLES.reglette.q.push({id:'sens',l:'Votre réglette est-elle alimentée d\'un seul côté ?',type:'select',
        opts:["Oui, et j'ai vérifié le sens du tube sur son indication","Oui, mais je n'ai pas vérifié le sens du tube","Non, elle est alimentée des deux côtés","Je ne sais pas"],req:false});
    }
  }catch(e){}
  var KEEP={
    ruban:['coupe','alim','sympt','enroule'],
    transfo:['charge','sympt','avide','variateur'],
    ampoule:['variateur','sympt','ferme','inter'],
    spot:['nb','sympt','driver'],
    plafonnier:['commande','sympt'],
    projecteur:['usage','sympt'],
    telecommande:['sympt','pile','zones','distance'],
    reglette:['serie','sympt','starter','sens'],
    connecte:['app','wifi','sympt'],
    autre:['sympt']
  };
  try{
    for(var fk in KEEP){
      if(FAMILLES[fk]&&FAMILLES[fk].q){
        FAMILLES[fk].q=FAMILLES[fk].q.filter(function(q){return KEEP[fk].indexOf(q.id)>=0;});
      }
    }
  }catch(e){}

  function fieldNS(pos,q){
    var a=ansAt(pos);
    var v=a[q.id]||'';var id='d'+pos+'_'+q.id;
    var req=q.req?' <span class="req">*</span>':'';
    if(q.type==='select'){
      var opts=['<option value="">— choisir —</option>'].concat(q.opts.map(function(o){return '<option '+(v===o?'selected':'')+'>'+o+'</option>';})).join('');
      return '<label class="f" for="'+id+'">'+q.l+req+'</label><select id="'+id+'">'+opts+'</select>';
    }
    if(q.type==='textarea'){
      return '<label class="f" for="'+id+'">'+q.l+req+'</label><textarea id="'+id+'" placeholder="'+(q.ph||'')+'">'+esc2(v)+'</textarea>';
    }
    return '<label class="f" for="'+id+'">'+q.l+req+'</label><input type="text" id="'+id+'" placeholder="'+(q.ph||'')+'" value="'+esc2(v)+'">';
  }
  var WHENQ={id:'when',l:'Quand le problème est-il apparu ?',type:'select',opts:["Dès la mise sous tension / au déballage","Après quelques jours","Après quelques semaines","Après plusieurs mois"],req:true};
  var GENSYMPT={id:'sympt',l:'Que se passe-t-il ?',type:'select',opts:["Ne s'allume pas","Scintille / clignote","Chauffe","Bruit anormal","Autre"],req:true};
  var AGAINQ={id:'again',l:'Est-ce la première fois avec ce produit ?',type:'select',opts:["Oui, première fois","Non, c'est déjà arrivé avec ce produit","Non, plusieurs exemplaires sont concernés"],req:true};
  var DESCQ={id:'desc',l:'Précisions (facultatif)',type:'textarea',ph:'Tout détail utile...'};

  VIEWS.diag=function(){
    var multi=posList().length>1;
    var h='<div class="step-label">Étape 4 · Autodiagnostic</div><h2 class="q">Décrivez le problème'+(multi?' produit par produit':'')+'</h2>'
      +'<p class="sub">Quelques précisions pour écarter les causes liées à l\'installation : c\'est ce qui résout une bonne partie des cas sans retour.</p>';
    posList().forEach(function(pos){
      var p=productAtPos(pos);var fam=famForPos(pos);var g=p?garantieDe(p):{known:false};
      h+='<div class="dprod">';
      h+='<div class="dprod-h">'+imgHtml(p,'')+'<div><b>'+esc2(labelAt(pos))+'</b>'
        +(g.known?'<span class="badge '+(g.in?'in':'out')+'">'+(g.in?'sous garantie · '+g.reste+' mois restants':'hors garantie')+'</span>':'')
        +'<span class="hint">'+esc2(qtyNote(pos))+'</span></div></div>';
      h+=fieldNS(pos,WHENQ);
      if(fam&&FAMILLES[fam]&&FAMILLES[fam].q.length){FAMILLES[fam].q.forEach(function(q){h+=fieldNS(pos,q);});}
      else{h+=fieldNS(pos,GENSYMPT);}
      h+=fieldNS(pos,AGAINQ);
      h+=fieldNS(pos,DESCQ);
      h+='</div>';
    });
    h+='<div class="err" id="e_q">Complétez les champs marqués * pour chaque produit.</div>';
    h+=navHTML('Voir le diagnostic');
    return h;
  };
  function collectDiag(){
    posList().forEach(function(pos){
      var key=prodKeyAt(pos);
      if(!S.diagByProd[key])S.diagByProd[key]={famille:null,answers:{}};
      S.diagByProd[key].famille=famForPos(pos);
      var a=S.diagByProd[key].answers;var fam=famForPos(pos);
      var ids=['when'].concat((fam&&FAMILLES[fam])?FAMILLES[fam].q.map(function(q){return q.id;}):['sympt']).concat(['again','desc']);
      ids.forEach(function(qid){var el=SGID('d'+pos+'_'+qid);if(el)a[qid]=el.value.trim();});
      if(a.again&&/^Non/i.test(a.again))S.flags.qualite=true;
    });
  }
  function diagManquants(){
    var miss=[];
    posList().forEach(function(pos){
      var a=ansAt(pos);
      if(!a.when)miss.push('d'+pos+'_when');
      if(!a.sympt)miss.push('d'+pos+'_sympt');
      if(!a.again)miss.push('d'+pos+'_again');
    });
    return miss;
  }

  function diagBlockHtml(pos,dr,loading){
    var p=productAtPos(pos);
    var head='<div class="dprod-h">'+imgHtml(p,'')+'<div><b>'+esc2(labelAt(pos))+'</b></div></div>';
    if(loading)return '<div class="dprod" data-dpos="'+pos+'">'+head+'<p class="sub" style="margin:10px 0 0">Analyse en cours…</p></div>';
    if(!dr||(!dr.cause&&(!dr.steps||!dr.steps.length)))
      return '<div class="dprod" data-dpos="'+pos+'">'+head+'<div class="tip">Pas de piste automatique évidente pour ce cas — notre service client examine votre cas en détail avec les éléments que vous avez fournis.</div></div>';
    var steps=(dr.steps||[]).map(function(x){return '<li>'+esc2(x)+'</li>';}).join('');
    var esch=dr.escalate?'<div class="tip"><b>Par sécurité —</b> ne tente aucune manipulation risquée. Envoie la demande, notre SAV prend le relais.</div>':'';
    var fix=(dr.fix_query||dr.fix)?('<p style="margin:10px 0 0"><b>Il vous manque peut-être une pièce :</b> <a href="/search?q='+encodeURIComponent(dr.fix_query||dr.fix)+'" target="_blank" rel="noopener">voir les '+esc2(dr.fix_label||dr.fix_query||dr.fix)+'</a></p>'):'';
    return '<div class="dprod" data-dpos="'+pos+'">'+head
      +(dr.cause?'<p style="margin:10px 0 4px"><b>Cause la plus probable :</b> '+esc2(dr.cause)+'</p>':'')
      +(steps?'<p style="margin:10px 0 2px"><b>À tester :</b></p><ul>'+steps+'</ul>':'')
      +fix+esch+'</div>';
  }
  VIEWS.result=function(){
    var neuf=false;
    posList().forEach(function(pos){if(/mise sous tension|déballage|deballage/i.test(ansAt(pos).when||''))neuf=true;});
    var h='<div class="step-label">Étape 5 · Diagnostic</div><h2 class="q">Voici notre diagnostic</h2>'
      +'<p class="sub">'+(neuf
        ? "Le problème est apparu dès la mise en service : dans ce cas, c'est presque toujours le branchement. Consultez les pistes ci-dessous et la notice de votre produit avant d'aller plus loin."
        : "Testez les pistes ci-dessous — beaucoup de cas se règlent ici. Sinon on prend le relais avec tout le contexte, vous n\'avez rien à réexpliquer.")+'</p>';
    posList().slice(0,2).forEach(function(pos){h+=t8Html(pos);});
    posList().forEach(function(pos){
      var a=ansAt(pos);var sd=safetyDiag(a);
      if(sd){S.diagResult[pos]=sd;h+=diagBlockHtml(pos,sd,false);}
      else if(DIAG_ENDPOINT){h+=diagBlockHtml(pos,null,true);}
      else{var fam=famForPos(pos);var rule=matchRule(fam,a)||{cause:'',steps:[],escalate:true};S.diagResult[pos]=rule;h+=diagBlockHtml(pos,rule,false);}
    });
    if(S.flags.qualite){
      h+='<div class="stat warn"><h4>Ce n\'est pas la première fois</h4>'
        +'<p>Nous n\'allons pas vous faire retester ce que vous avez déjà testé. La référence part au service qualité avec le numéro de lot, et votre dossier est traité en priorité.</p></div>';
    }
    if(garantieOut()){
      h+='<div class="stat warn"><h4>Ce produit est sorti de garantie</h4>'
        +'<p>Nous vous le disons maintenant plutôt que de vous faire attendre une semaine pour la même réponse. L\'écran suivant vous explique ce que nous pouvons faire.</p></div>';
    }
    var multiR=posList().length>1;
    posList().slice(0,2).forEach(function(pos){
      h+=resHtml(pos,
        multiR?('La documentation de « '+labelAt(pos)+' »'):'La documentation de votre produit',
        neuf?"Consultez d'abord le montage : la notice livrée avec le produit et le tutoriel vidéo reprennent le branchement pas à pas."
            :"La grande majorité des pannes signalées sont des problèmes de branchement. Deux minutes ici peuvent vous éviter un retour.");
    });
    h+='<div class="actions">'
      +'<button class="btn ghost" id="solvedok">✅ C\'est résolu, merci</button>'
      +'<button class="btn primary" id="tosav">Le problème persiste — continuer →</button></div>'
      +'<div style="margin-top:14px"><button class="link" id="backl">← Revenir aux réponses</button></div>'
      +'<p class="muted">Si vous testez maintenant et que le problème persiste, revenez : votre dossier reste ouvert de notre côté.</p>';
    return h;
  };
  function setupResult(){
    bindRes();
    /* BOUCLE DE RENDU : la version d'origine relancait render() des que le bloc
       .reslist n'etait pas encore la. Sur un catalogue sans notice ni fiche ni
       video, ce bloc n'existe JAMAIS : render() rappelait setupResult, qui
       rappelait loadRes, qui rappelait render... L'ecran se redessinait en
       continu et les boutons, detruits puis recrees, ne recevaient jamais leur
       clic. On ne redessine donc que s'il y a REELLEMENT quelque chose de
       nouveau a afficher, et une seule fois. */
    loadRes(0,function(){
      if(S._resRender)return;
      var r=resFor(0)||{};
      var aQuoiAfficher=!!(r.notice||r.fiche||r.video||(r.guides&&r.guides.length));
      if(!aQuoiAfficher)return;
      if(app.querySelector('.reslist'))return;
      if(!app.querySelector('#solvedok'))return;
      S._resRender=1;
      render();
    });
    var ok=SGID('solvedok');
    if(ok)ok.onclick=function(){
      S.sortie='S1';
      var dr=S.diagResult[posList()[0]]||{},p=productAtPos(0);
      doAction('diag_resolu',{sku:p?skuOf(p):'',famille:famForPos(0)||'',
        symptome:(ansAt(posList()[0]).sympt||''),cause:(dr.cause||'')},function(){});
      endOk('Parfait, nous sommes ravis que ce soit résolu.','Nous conservons la trace de la cause : c\'est ce qui nous permet de corriger la notice et la fiche produit pour les clients suivants.');
    };
    var go=SGID('tosav');if(go)go.onclick=function(){S.step++;render();};
    var bl=SGID('backl');if(bl)bl.onclick=function(){if(S.step>0){S.step--;render();}};
    if(!DIAG_ENDPOINT)return;
    var need=[];
    posList().forEach(function(pos){
      var a=ansAt(pos);if(safetyDiag(a))return;
      var p=productAtPos(pos);var g=p?garantieDe(p):{};
      need.push({pos:pos,name:labelAt(pos),famille:famForPos(pos)||'',answers:a,sku:p?skuOf(p):'',garantie:g.known?(g.in?'in':'out'):''});
    });
    if(!need.length)return;
    function paint(pos){var host=app.querySelector('.dprod[data-dpos="'+pos+'"]');if(host)host.outerHTML=diagBlockHtml(pos,S.diagResult[pos],false);}
    function fallback(n){S.diagResult[n.pos]=matchRule(n.famille,n.answers)||{cause:'',steps:[],escalate:true};paint(n.pos);}
    askIA({kind:'diag',items:need.map(function(n){return {name:n.name,famille:n.famille,answers:n.answers,sku:n.sku,garantie:n.garantie};})},
      function(d){
        var diags=(d&&d.diagnostics)||[];
        need.forEach(function(n,i){
          var dr=diags[i];
          if(!dr||(!dr.cause&&(!dr.steps||!dr.steps.length))){fallback(n);return;}
          S.diagResult[n.pos]={cause:dr.cause||'',steps:dr.steps||[],escalate:!!dr.escalate,
            fix_query:dr.fix_query||'',fix_label:dr.fix_label||''};
          paint(n.pos);
        });
      },
      function(){need.forEach(fallback);});
  }

  /* --- ecran hors garantie : celui qui vend --- */
  VIEWS.hg=function(){
    var p=productAtPos(0),g=p?garantieDe(p):{};
    var h='<div class="step-label">Garantie</div>'
      +'<h2 class="q">Ce produit n\'est plus sous garantie</h2>'
      +'<div class="stat warn"><p>'
      +esc2(labelAt(0))+(g.date?' a été acheté le '+esc2(frDate(g.date)):'')
      +(g.age!=null?', il y a '+esc2(ageTexte(g.age)):'')
      +'. La garantie de '+esc2(g.mois||24)+' mois est dépassée : nous ne pouvons pas le remplacer gratuitement, et nous préférons vous le dire clairement plutôt que de vous faire attendre une semaine pour la même réponse.</p>'
      +'<p>Cela dit, un produit qui tombe en panne à cet âge nous intéresse : la référence est transmise à notre service qualité. Vos retours nous servent à sélectionner nos fournisseurs.</p></div>'
      +'<h2 class="q" style="font-size:20px;margin-top:26px">Ce que nous pouvons faire</h2>'
      +'<div id="althost"><p class="sub">Recherche des équivalents en stock…</p></div>'
      +'<div class="stat ok"><h4>Un geste commercial de 10 % sur le remplacement</h4>'
      +'<p>Parce que ce produit n\'a pas tenu ce que nous annonçons, un conseiller peut vous transmettre un code de <b>-10 %</b> sur le modèle équivalent, valable 30 jours. Demandez-le ici, il vous répond avant le '+engagement(1)+'.</p>'
      +'<div style="margin-top:12px"><button class="btn primary" id="geste">Demander mon geste commercial</button></div></div>'
      +'<div class="actions">'
      +'<button class="btn ghost" id="hgok">Merci, c\'est clair</button>'
      +'<button class="btn primary" id="hgsav">Je souhaite en parler à un conseiller →</button></div>'
      +'<p class="muted">Un conseiller peut aussi étudier un geste plus important selon l\'ancienneté et le montant : c\'est lui qui tranche, sous 24 h ouvrées.</p>';
    return h;
  };
  function setupHg(){
    var ok=SGID('hgok');
    if(ok)ok.onclick=function(){S.sortie='S1';endOk('Merci de nous l\'avoir signalé','La référence est transmise au service qualité avec votre description. C\'est ce qui nous permet de sortir les mauvaises séries du catalogue.');};
    var go=SGID('hgsav');if(go)go.onclick=function(){S.escal='hors garantie — demande de geste commercial';S.step++;render();};
    var gb=SGID('geste');
    if(gb)gb.onclick=function(){
      var p=productAtPos(0);
      S.flags.geste10=true;
      gb.disabled=true;gb.textContent='Envoi du code…';
      doAction('geste_hors_garantie',{sku:p?skuOf(p):'',product:labelAt(0)},function(ok){
        if(ok){gb.textContent='Demande enregistrée ✓';}
        else{S.escal='geste commercial de 10 % à étudier';gb.textContent='Un conseiller revient vers vous';}
      });
    };
    loadAlt('hors_garantie',SGID('althost'));
  }

  /* --- alternatives produit (hors garantie + sauvetage retour) --- */
  function altHtml(a){
    var aim=safeImg(a.image),aur=safeUrl(a.url);
    return '<div class="alt">'+(aim?'<img src="'+esc2(aim)+'" alt="">':'<div class="pph" style="width:64px;height:64px;border-radius:8px"></div>')
      +'<div><div class="n">'+esc2(a.title||a.name||'')+'</div>'
      +'<div class="p">'+esc2(a.price?money(a.price):'')
      +(a.stock?' · En stock':'')
      +(a.delta?' · '+esc2(a.delta):'')
      +(a.reason?' — '+esc2(a.reason):'')+'</div></div>'
      +(aur?'<div class="go"><a class="btn ghost" href="'+esc2(aur)+'" target="_blank" rel="noopener">Voir le produit</a></div>':'')
      +'</div>';
  }
  function loadAlt(contexte,host){
    if(!host)return;
    var p=productAtPos(0);
    var payload={kind:'alt',contexte:contexte,
      sku:p?skuOf(p):'',product:labelAt(0),
      handle:(p&&p.handle)||'',motif:S.answers.rmotif||'',order:(S.order&&S.order.id)||''};
    askIA(payload,function(d){
      try{
        if(d&&d.source&&d.source.handle){
          S.srcProduit={handle:d.source.handle,title:d.source.title||'',url:safeUrl(d.source.url||('/products/'+d.source.handle))};
          if(S.motif==='stock'&&flow()[S.step]==='stock')render();
        }
      }catch(e){}
      var list=(d&&(d.alternatives||d.alt))||[];
      if(!list.length){altFallback(host);return;}
      S.alt=list;
      host.innerHTML=list.slice(0,3).map(altHtml).join('')
        +'<p class="muted">Disponibilité indiquée au moment de votre consultation.</p>';
    },function(){altFallback(host);});
  }
  function altFallback(host){
    var q=encodeURIComponent((labelAt(0)||'').replace(/\s+/g,' ').slice(0,60));
    host.innerHTML='<div class="tip">Nous n\'avons pas pu charger les équivalents automatiquement. '
      +'<a href="/search?q='+q+'" target="_blank" rel="noopener">Voir les modèles équivalents</a> — ou sollicitez un conseiller ci-dessous, il vous proposera la bonne référence.</div>';
  }

  /* ============================================================
     17. BRANCHE 6 - RETOUR, RETRACTATION
     ============================================================ */
  var RMOTIFS=[
    "Les dimensions ne correspondent pas à ce que j'attendais",
    "La couleur ou la température de lumière ne convient pas",
    "La puissance est insuffisante ou trop forte",
    "Ce n'est pas compatible avec mon installation",
    "J'ai commandé en trop grande quantité",
    "J'ai changé d'avis"
  ];
  VIEWS.q_retract=function(){
    var j=joursDepuisReception();
    var h='<div class="step-label">Étape 4 · Retour</div><h2 class="q">Qu\'est-ce qui ne convient pas avec ce produit ?</h2>'
      +'<p class="sub">Votre réponse ne sert pas qu\'à votre dossier : si dix clients retournent le même produit pour la même raison, c\'est la fiche produit que nous corrigeons.</p>'
      +field({id:'rmotif',l:'Motif du retour',type:'select',opts:RMOTIFS,req:true})
      +field({id:'used',l:'État du produit',type:'select',opts:["Neuf, jamais ouvert","Ouvert mais non installé","Installé / testé"],req:true})
      +field({id:'desc',l:'Précisions (facultatif)',type:'textarea',ph:'ex : je pensais que 120 cm correspondait à mon plan de travail'});
    if(j!=null&&j>14){
      h+='<div class="stat warn"><h4>Le délai de rétractation de 14 jours est dépassé</h4>'
        +'<p>Votre commande a été reçue il y a '+esc2(j)+' jours. Nous pouvons néanmoins chercher une solution : échange contre un équivalent, ou avoir. Nous vous le disons maintenant plutôt qu\'après un retour inutile.</p></div>';
    }else if(j!=null){
      h+='<div class="stat ok"><p>Vous êtes dans le délai de rétractation : '+esc2(Math.max(0,14-j))+' jour(s) restant(s).</p></div>';
    }
    h+='<div class="err" id="e_q">Indiquez le motif et l\'état du produit.</div>'+navHTML('Continuer');
    return h;
  };
  VIEWS.sauvetage=function(){
    var j=joursDepuisReception(),hors=(j!=null&&j>14);
    var h='<div class="step-label">Étape 5 · Avant de valider</div>'
      +'<h2 class="q">Nous avons peut-être ce qu\'il vous faut</h2>'
      +'<p class="sub">Avant de renvoyer quoi que ce soit : un échange coûte souvent moins cher qu\'un retour, pour vous comme pour nous.</p>'
      +'<div id="althost"><p class="sub">Recherche des équivalents en stock…</p></div>'
      +'<h2 class="q" style="font-size:20px;margin-top:26px">Quelle solution vous convient le mieux ?</h2>'
      +decHtml([
        ['echange','Échanger contre un équivalent','Nous vous envoyons le modèle correspondant. Selon le montant, vous n\'avez parfois rien à nous renvoyer : le conseiller vous le confirme.'],
        ['avoir','Un avoir majoré de 10 %','Un avoir sans limite de durée, majoré de 10 % par rapport au montant remboursé. C\'est l\'option qui aboutit le plus rapidement.'],
        ['numeraire','Un remboursement sur mon moyen de paiement','Remboursement sur le moyen de paiement d\'origine, dans la limite légale de 14 jours calendaires.']
      ]);
    if(hors){
      h+='<div class="tip">Hors délai de rétractation, l\'échange et l\'avoir restent possibles en geste commercial. Le remboursement numéraire sera arbitré par un conseiller.</div>';
    }else{
      h+='<div class="tip">Frais de retour : à votre charge en cas de rétractation (produit complet, en état de revente). Ils sont à notre charge si le produit est défectueux, abîmé ou si l\'erreur vient de nous.</div>';
    }
    h+='<div class="err" id="e_dec">Sélectionnez la solution qui vous convient.</div>'+navHTML('Valider mon choix');
    return h;
  };
  function setupSauvetage(){bindDec();loadAlt('retour',SGID('althost'));}

  /* ============================================================
     18. BRANCHE 7a - CONSEIL / QUESTION PRODUIT
     ============================================================ */
  VIEWS.conseil=function(){
    var h='<div class="step-label">Étape 2 · Votre question</div><h2 class="q">Posez votre question</h2>'
      +'<p class="sub">Compatibilité, puissance, installation, garantie : on répond ici à partir de nos fiches produit, guides et notices.</p>'
      +field({id:'desc',l:'Votre question',type:'textarea',ph:"ex : quel transfo pour 8 m de ruban 14,4 W/m ? / ce spot est-il compatible avec un variateur ?",req:true})
      +'<label class="f">Produit concerné <span class="hint">(facultatif — nom, référence ou lien de la fiche produit)</span></label>'
      +'<input type="text" id="pfree" placeholder="ex : Ruban LED 24V 14,4W/m" value="'+esc2(S.answers.pfree||'')+'">'
      +'<div class="err" id="e_q">Rédigez votre question.</div>'+navHTML('Obtenir une réponse');
    return h;
  };
  function questionPayload(){
    var prods=orderMode()?posList().map(function(pos){var p=productAtPos(pos);return {name:labelAt(pos),sku:(p?skuOf(p):'')};}):[];
    if(!prods.length&&S.answers.pfree)prods=[{name:S.answers.pfree,sku:''}];
    return {kind:(S.motif==='conseil'?'conseil':'question'),
      question:(S.answers.desc||'').trim(),motif:S.motif||'',
      order:(S.order&&S.order.id)||'',products:prods,
      page:(function(){try{return document.location.href;}catch(e){return '';}})()};
  }
  VIEWS.gresult=function(){
    var q=(S.answers.desc||'').trim();
    var h='<div class="step-label">Réponse</div><h2 class="q">Voici notre réponse</h2>'
      +'<p class="sub">Si elle vous convient, inutile d\'ouvrir un dossier ou d\'attendre.</p>'
      +'<div class="dprod" data-qres="1">'
      +(q?'<p style="margin:0 0 6px"><b>Votre question :</b> '+esc2(q)+'</p>':'')
      +(DIAG_ENDPOINT?'<p class="sub" style="margin:6px 0 0">Analyse en cours…</p>':'<div class="tip">Un conseiller vous répond en détail avant '+engagement(1)+'.</div>')
      +'</div>'
      +'<div id="qres"></div>'
      +'<div class="actions">'
      +'<button class="btn ghost" id="qok">Ma question est résolue, merci</button>'
      +'<button class="btn primary" id="qsav">La réponse ne convient pas — parler à un conseiller →</button></div>'
      +'<div style="margin-top:14px"><button class="link" id="qback">Reformuler ma question</button></div>';
    return h;
  };
  function setupGresult(){
    var ok=SGID('qok');
    if(ok)ok.onclick=function(){
      S.sortie='S1';
      doAction('question_resolue',{question:(S.answers.desc||'')},function(){});
      endOk('Parfait !','Nous sommes ravis d\'avoir pu vous aider. Aucune demande n\'a été envoyée, revenez quand vous le souhaitez.');
    };
    var go=SGID('qsav');if(go)go.onclick=function(){S.escal='réponse IA insuffisante';S.step++;render();};
    var bk=SGID('qback');if(bk)bk.onclick=function(){if(S.step>0){S.step--;render();}};
    var host=app.querySelector('.dprod[data-qres="1"]');
    var q=(S.answers.desc||'').trim();
    function paint(ans,escalate,sources){
      if(!host)return;
      var html=(q?'<p style="margin:0 0 6px"><b>Votre question :</b> '+esc2(q)+'</p>':'');
      if(ans)html+='<p style="margin:6px 0 0"><b>Réponse :</b> '+esc2(ans)+'</p>';
      else html+='<div class="tip">Un conseiller vous répond en détail avant '+engagement(1)+'.</div>';
      if(sources&&sources.length){
        html+='<p style="margin:10px 0 2px"><b>Pour aller plus loin :</b></p><ul>'
          +sources.slice(0,3).map(function(s){
             var u=safeUrl(s.url);
             return u?('<li><a href="'+esc2(u)+'" target="_blank" rel="noopener">'+esc2(s.title||u)+'</a></li>')
                     :('<li>'+esc2(s.title||'')+'</li>');
           }).join('')
          +'</ul>';
      }
      if(escalate)html+='<div class="tip">Cette demande concerne votre commande : un conseiller la traite avec votre dossier, avant le '+engagement(1)+'.</div>';
      host.innerHTML=html;
      var extra=SGID('qres');
      if(extra){
        loadRes(0,function(){
          var rh=resHtml(0,'La documentation du produit',"Notice, tutoriel vidéo et fiche technique : de quoi vérifier le montage sans attendre.");
          if(rh){extra.innerHTML=rh;bindRes();}
        });
      }
    }
    /* Un ecran ne doit jamais rappeler un webhook a chaque rendu. La cle depend
       de la question, donc une reformulation refait bien un appel. */
    var cleQ='q|'+q;
    if(S._iaFait===cleQ){paint(S._iaRep||'',!!S._iaEsc,S._iaSrc||[]);return;}
    S._iaFait=cleQ;
    askIA(questionPayload(),function(d){
      S._iaRep=(d&&d.answer)||'';S._iaEsc=!!(d&&d.escalate);S._iaSrc=(d&&d.sources)||[];
      paint(S._iaRep,S._iaEsc,S._iaSrc);
    },function(){
      S._iaRep='';S._iaEsc=true;S._iaSrc=[];
      paint('',true,[]);
    });
  }

  /* ============================================================
     18bis. BRANCHE - AUTRE DEMANDE, classee par IA
     ============================================================ */
  var CLASSABLE={suivi:1,nonrecu:1,casse:1,prepa:1,defaut:1,retract:1,facture:1,conseil:1,stock:1,devis:1};

  /* ------------------------------------------------------------------
     Classement local de la demande libre.
     Il s'execute AVANT l'appel a l'IA, pour deux raisons : il est instantane,
     et il ne depend d'aucun webhook. Une phrase aussi explicite que
     « je veux faire une demande de devis » ne doit pas attendre une reponse
     reseau, ni echouer si le workflow de classement n'existe pas encore.
     L'IA reste appelee pour tout ce que ces regles ne reconnaissent pas.
     ORDRE VOLONTAIRE : le commercial passe en premier — une demande de devis
     qui contient « produit » ou « commande » ne doit pas partir en SAV.
     ------------------------------------------------------------------ */
  var REGLES=[
    ['devis',   /devis|chantier|tarif\s*(pro|profession)|prix\s*pro|revendeur|revente|grossiste|siret|gros(se)?\s*(volume|quantit)|appel d'offre|budget/i],
    ['facture', /factur|duplicata|justificatif comptab|num[ée]ro de tva|bon de commande/i],
    /* « pas reçu » seul veut dire « où est mon colis » : ce n'est PAS un colis
       non remis. Il faut la mention d'une livraison annoncee, ou « jamais ». */
    ['nonrecu', /jamais\s+re[cç]u|(marqu|indiqu|annonc|affich|dit|soi[- ]disant)\w*\s+(comme\s+)?livr|livr[ée]\w*\s+(mais|or|pourtant|alors|et\s+(je|rien))|colis\s+(non|jamais)\s+re[cç]u|d[ée]pos[ée]\s+chez\s+(un\s+)?voisin|rien\s+re[cç]u/i],
    ['casse',   /ab[îi]m|cass[ée]|endommag|fissur|bris[ée]|[ée]cras[ée]|colis.*d[ée]t[ée]rior/i],
    ['prepa',   /manqu|il me manque|pas le bon|mauvais (produit|article|r[ée]f)|erreur de (pr[ée]paration|colis|r[ée]f)|autre produit que/i],
    ['defaut',  /d[ée]fectueu|ne s['\s]?allume|s['\s]?allume plus|ne fonctionne|fonctionne plus|en panne|clignote|scintill|grill[ée]|hors service|\bhs\b|marche plus|court[- ]circuit|fait disjoncter/i],
    ['retract', /r[ée]tractation|retourner|renvoyer|rembours|[ée]change|ne (me )?convient pas|chang[ée]? d'avis|annuler (ma|la) commande|trop (grand|petit|puissant)/i],
    ['stock',   /rupture|r[ée]approvisionn|de nouveau (en )?stock|quand sera|pr[ée]venez[- ]moi|disponibilit|plus en stock|indisponible/i],
    ['suivi',   /o[uù] (est|en est)|suivi|tracking|num[ée]ro de suivi|d[ée]lai de livraison|toujours pas (re[cç]u|livr)|colis en retard|pas encore (re[cç]u|livr)|livraison/i],
    ['conseil', /conseil|compatib|quelle puissance|quel mod[èe]le|comment (installer|brancher|choisir)|branchement|question technique|diff[ée]rence entre|recommand/i]
  ];
  function classerLocal(txt){
    /* Apostrophes typographiques ramenees a l'apostrophe simple : sur mobile,
       « ne s'allume pas » s'ecrit avec U+2019 neuf fois sur dix. */
    var t=String(txt||'').replace(/[\u2018\u2019\u00B4`]/g,"'");
    if(t.replace(/\s+/g,' ').trim().length<6)return null;
    for(var i=0;i<REGLES.length;i++){
      if(REGLES[i][1].test(t))return REGLES[i][0];
    }
    return null;
  }
  VIEWS.autre=function(){
    return '<div class="step-label">Étape 2 · Votre demande</div><h2 class="q">Décrivez-nous votre situation</h2>'
      +'<p class="sub">Rédigez-la avec vos mots. Nous la lisons et vous orientons directement au bon endroit ; si elle n\'entre dans aucune catégorie, elle part telle quelle à un conseiller.</p>'
      +field({id:'libre',l:'Votre demande',type:'textarea',ph:"ex : j'ai commandé deux fois le même article par erreur et je voudrais annuler la seconde commande",req:true})
      +'<label class="f">Numéro de commande <span class="hint">(si vous l\'avez sous la main — facultatif)</span></label>'
      +'<input type="text" id="ord2" placeholder="#291234" value="'+esc2(S.answers.ordlibre||'')+'">'
      +'<div class="err" id="e_libre">Rédigez votre demande pour que nous puissions vous orienter.</div>'
      +navHTML('Continuer');
  };
  VIEWS.autreres=function(){
    return '<div class="step-label">Orientation</div><h2 class="q">Nous examinons votre demande</h2>'
      +'<div class="dprod" data-cls="1"><p class="sub" style="margin:0">Lecture en cours…</p></div>'
      +'<div id="clsact"></div>'
      +'<div style="margin-top:14px"><button class="link" id="clsback">← Modifier ma demande</button></div>';
  };
  function setupAutreres(){
    var host=app.querySelector('.dprod[data-cls="1"]');
    var act=SGID('clsact');
    var txt=(S.answers.libre||'').trim();
    var bk=SGID('clsback');
    if(bk)bk.onclick=function(){if(S.step>0){S.step--;render();}};

    function rappel(){return '<p style="margin:0 0 8px"><b>Votre demande :</b> '+esc2(txt)+'</p>';}
    function libre(msg){
      if(host)host.innerHTML=rappel()+'<div class="tip">'+esc2(msg)+'</div>';
      if(act)act.innerHTML='<div class="actions"><button class="btn primary" id="clsgo">Continuer — laisser mes coordonnées →</button></div>';
      var b=SGID('clsgo');
      if(b)b.onclick=function(){S.escal=S.escal||'demande libre, hors parcours';S.step++;render();};
    }
    function proposer(br,resume){
      var m=MOTIFS[br];
      if(host)host.innerHTML=rappel()
        +'<p style="margin:0"><b>Si nous comprenons bien, votre demande relève de :</b> '
        +esc2(resume||m.t)+'</p>';
      if(act)act.innerHTML='<div class="stat ok"><h4>'+m.ico+' '+esc2(m.t)+'</h4>'
        +'<p>Ce parcours pose les bonnes questions pour ce cas — c\'est la voie la plus rapide.</p></div>'
        +'<div class="actions"><button class="btn primary" id="clsyes">Oui, c\'est ça — continuer →</button>'
        +'<button class="btn ghost" id="clsno">Non, envoyer ma demande telle quelle</button></div>';
      var y=SGID('clsyes');
      if(y)y.onclick=function(){
        S.motif=br;
        if(br==='conseil'||br==='stock'||br==='devis')S.answers.desc=txt;
        S.flags.reclasse=br;
        S.step=1;render();
      };
      var n=SGID('clsno');
      if(n)n.onclick=function(){S.escal='le client a refusé le parcours proposé ('+br+')';libre('Votre demande part telle quelle à un conseiller, avec vos mots.');};
    }

    /* 1. Regles locales : instantanees, sans dependance reseau. */
    var brLocal=classerLocal(txt);
    if(brLocal&&CLASSABLE[brLocal]){proposer(brLocal,'');return;}

    /* 2. Sinon seulement, on demande a l'IA. */
    askIA({kind:'classify',text:txt,order:(S.answers.ordlibre||'')},function(d){
      var br=(d&&d.branche||'').toLowerCase();
      if(br&&CLASSABLE[br])proposer(br,(d&&d.resume)||'');
      else libre((d&&d.message)||('Votre demande sort de nos parcours habituels : un conseiller la lit et vous répond avant le '+engagement(1)+'.'));
    },function(){
      libre('Un conseiller lit votre demande et vous répond avant le '+engagement(1)+'.');
    });
  }

  /* ============================================================
     19. BRANCHE - FACTURE
     ============================================================ */
  VIEWS.facture=function(){
    var inv={url:safeUrl(((S.order&&S.order.invoice)||{}).url)};
    var ch=((S.order&&S.order.channel)||'').toLowerCase();
    var marketplace=/amazon|manomano|cdiscount|leroy|castorama|kaufland|bol|conrad|temu|brico/.test(ch);
    var h='<div class="step-label">Étape 3 · Facture</div><h2 class="q">Votre facture</h2>';
    if(marketplace){
      h+='<div class="stat warn"><h4>Cette commande a été passée sur '+esc2(S.order.channel)+'</h4>'
        +'<p>Pour ces commandes, la facture est émise et mise à disposition par la marketplace, dans votre espace acheteur, rubrique « Mes commandes ». Nous ne pouvons pas l\'éditer à leur place.</p></div>'
        +'<div class="actions"><button class="btn ghost" id="okfin">C\'est bon, merci</button>'
        +'<button class="btn primary" id="toct">Elle est introuvable — aidez-moi →</button></div>';
      return h;
    }
    h+='<div class="stat ok"><h4>Votre facture est disponible dans votre compte client</h4>'
      +'<p>Elle vous est envoyée par mail dès l\'expédition du colis, et reste téléchargeable à tout moment depuis votre compte, sur le détail de la commande '
      +esc2((S.order&&S.order.id)||'')+'.</p>'
      +'<div class="actions" style="margin-top:14px">'
      +(inv.url?'<a class="btn primary" href="'+esc2(inv.url)+'" target="_blank" rel="noopener">Voir ma commande et ma facture</a>':'')
      +(S.cust?'':'<a class="btn ghost" href="'+esc2(URL_COMPTE)+'" target="_blank" rel="noopener">Ouvrir mon compte client</a>')
      +'<button class="btn ghost" id="resend">Me la renvoyer par mail</button>'
      +'</div></div>'
      +'<p class="muted">Le mail part sur '+esc2(S.contact.email||(S.order&&S.order.email)||'l\'adresse de la commande')+'. Pensez à vérifier vos indésirables.</p>'
      +'<div class="actions">'
      +'<button class="btn ghost" id="okfin">C\'est bon, merci</button>'
      +'<button class="btn primary" id="toct">Il me faut autre chose (facture à un autre nom, TVA, société) →</button></div>';
    return h;
  };
  function setupFacture(){
    var rs=SGID('resend');
    if(rs)rs.onclick=function(){
      rs.disabled=true;rs.textContent='Envoi…';
      doAction('facture_renvoi',{},function(ok){
        if(ok){
          S.sortie='S2';
          endAuto('C\'est noté','Nous vous renvoyons votre facture à l\'adresse '+esc2(S.contact.email||(S.order&&S.order.email)||'votre adresse')+'. Si vous ne la voyez pas, pensez à vérifier vos indésirables, puis revenez ici : nous vous la transmettrons autrement.');
        }else{
          S.escal='renvoi de facture à faire manuellement';
          S.step++;render();
        }
      });
    };
    var ok=SGID('okfin');
    if(ok)ok.onclick=function(){S.sortie='S1';endOk('Parfait !','Votre facture reste disponible à tout moment dans votre compte client.');};
    var go=SGID('toct');if(go)go.onclick=function(){S.escal='facture — cas particulier';S.step++;render();};
  }

  /* ============================================================
     20. BRANCHE - DEVIS / PRO  (sortie S4, hors file SAV)
     ============================================================ */
  VIEWS.devis=function(){
    return '<div class="step-label">Étape 2 · Demande commerciale</div>'
      +'<h2 class="q">Votre demande part au pôle commercial</h2>'
      +'<div class="stat ok"><p>Un devis, un chantier, une quantité, un tarif professionnel : ce n\'est pas du service après-vente. '
      +'Notre formulaire de devis capte les bonnes informations dès le départ (quantités, échéance, type de projet) et va directement à un commercial, '
      +'<b>hors file SAV</b>, avec un rappel sous 4 h ouvrées.</p></div>'
      +'<div class="actions">'
      +'<a class="btn primary" href="'+esc2(URL_DEVIS+(URL_DEVIS.indexOf('?')<0?'?':'&')+'origine=formulaire-contact')+'">Faire ma demande de devis →</a>'
      +'<button class="btn ghost" id="toct">Ma demande n\'est pas commerciale</button></div>'
      +'<p class="muted">Vous êtes déjà client professionnel ? Indiquez votre numéro de SIRET dans le formulaire : votre dossier est affecté nominativement à votre interlocuteur.</p>';
  };
  function setupDevis(){
    var go=SGID('toct');if(go)go.onclick=function(){S.step++;render();};
  }

  /* ============================================================
     21. BRANCHE - RUPTURE / DISPONIBILITE
     ============================================================ */
  VIEWS.stock=function(){
    return '<div class="step-label">Étape 2 · Disponibilité</div>'
      +'<h2 class="q">Quel produit attendez-vous ?</h2>'
      +'<p class="sub">Nous vous prévenons dès le retour en stock, et vous présentons les équivalents disponibles dès maintenant.</p>'
      +'<label class="f">Produit ou référence <span class="req">*</span></label>'
      +'<input type="text" id="pfree" placeholder="ex : Réglette LED 150cm 72W" value="'+esc2(S.answers.pfree||'')+'">'
      +'<label class="f">Email pour l\'alerte'+(S.srcProduit&&S.srcProduit.url?' <span class="hint">(facultatif — utile seulement si vous préférez que nous vous répondions)</span>':' <span class="req">*</span>')+'</label>'
      +'<input type="email" id="s_mail" value="'+esc2(S.contact.email||'')+'" placeholder="vous@email.fr">'
      +field({id:'qte',l:'Quantité souhaitée (facultatif)',type:'text',ph:'ex : 12'})
      +(S.srcProduit&&S.srcProduit.url
        ? '<div class="stat ok"><h4>Produit identifié : '+esc2(S.srcProduit.title||S.srcProduit.handle)+'</h4>'
          +'<p>L\'alerte de disponibilité se pose directement sur la fiche produit, bouton '
          +'« M\'avertir lorsque le produit sera disponible ». C\'est le même système que celui qui '
          +'vous préviendra : vous recevez un mail dès le retour en stock, sans passer par notre service client.</p>'
          +'<div class="actions" style="margin-top:12px">'
          +'<a class="btn primary" href="'+esc2(S.srcProduit.url)+'" target="_blank" rel="noopener">M\'avertir sur la fiche produit →</a>'
          +'</div></div>'
        : '<div class="actions">'
          +'<button class="btn primary" id="alerte">M\'alerter dès le retour en stock</button></div>')
      +'<div class="err" id="e_stock">Indiquez le produit et un email valide.</div>'
      +'<div id="althost" style="margin-top:22px"></div>'
      +'<div class="actions">'
      +'<button class="btn ghost" id="toct">J\'ai besoin d\'une date ferme pour un chantier →</button></div>'
      +'<p class="muted">L\'alerte de disponibilité est présente sur chaque fiche produit en rupture : bouton « M\'avertir lorsque le produit sera disponible ».</p>';
  };
  function setupStock(){
    var b=SGID('alerte');
    if(b)b.onclick=function(){
      var pf=SGID('pfree'),m=SGID('s_mail'),q=SGID('f_qte');
      S.answers.pfree=(pf?pf.value:'').trim();
      S.contact.email=(m?m.value:'').trim();
      S.answers.qte=(q?q.value:'').trim();
      if(!S.answers.pfree||!validEmail(S.contact.email)){showErr('e_stock');return;}
      b.disabled=true;b.textContent='Enregistrement…';
      loadAlt('rupture',SGID('althost'));
      doAction('alerte_stock',{product:S.answers.pfree,qte:S.answers.qte},function(ok){
        if(ok){
          S.sortie='S2';
          endAuto('Alerte enregistrée','Vous recevrez un mail à l\'adresse '+esc2(S.contact.email)+' dès le retour en stock de « '+esc2(S.answers.pfree)+' ». Vous n\'avez aucune autre démarche à effectuer.');
        }else{
          /* on n'annonce jamais un enregistrement qui n'a pas eu lieu : on passe la main */
          S.escal='alerte de disponibilité à créer manuellement';
          S.step++;render();
        }
      });
    };
    var pf=SGID('pfree');
    if(pf)pf.onblur=function(){
      S.answers.pfree=pf.value.trim();
      if(S.answers.pfree.length>3)loadAlt('rupture',SGID('althost'));
    };
    var go=SGID('toct');
    if(go)go.onclick=function(){
      var pf2=SGID('pfree'),m2=SGID('s_mail');
      S.answers.pfree=(pf2?pf2.value:'').trim();
      if(m2&&m2.value.trim())S.contact.email=m2.value.trim();
      S.escal='rupture — besoin d\'une date d\'approvisionnement';S.step++;render();
    };
  }

  /* ============================================================
     22. PHOTOS - gabarit impose ou depot libre
     ============================================================ */
  VIEWS.photo=function(){
    var G=gabaritFor();
    if(!G){
      return '<div class="step-label">Pièces jointes</div><h2 class="q">Ajoute une photo ou une vidéo <span class="hint">(facultatif)</span></h2>'
      +'<p class="sub">Ce n\'est pas obligatoire, mais une photo accélère beaucoup le traitement.</p>'
      +'<input type="file" id="fileinput" accept="image/*,video/*" multiple style="display:none">'
      +'<div class="drop" id="drop">Glissez vos fichiers ici ou <u>cliquez pour parcourir</u><br><span class="hint">Photos ou vidéo — plusieurs fichiers possibles</span></div>'
      +'<div class="thumbs" id="filelist"></div>'
      +'<div class="err" id="e_photo"></div>'+navHTML();
    }
    var intro=(S.motif==='casse')?'Trois photos, et votre dossier est complet.'
      :(S.motif==='prepa'?'Deux photos, et votre dossier est complet.'
      :'Deux photos, pour que le diagnostic aille droit au but.');
    var h='<div class="step-label">Pièces jointes</div><h2 class="q">'+intro+'</h2>'
      +'<p class="sub">Chaque emplacement attend une photo précise. Cadre comme le schéma : c\'est ce qui fait la différence entre un dossier traité d\'un coup et trois allers-retours par mail.</p>'
      +'<div class="slots">';
    G.forEach(function(s){
      var f=fileInSlot(s.id);
      h+='<div class="slot '+(f?'filled':'')+'" data-slot="'+s.id+'">'
        +(f?'<button type="button" class="rmv" data-rm="'+s.id+'">✕</button>':'')
        +'<div class="st">'+esc2(s.t)+'</div>'
        +((f&&safeImg(f.thumb))?'<img class="prev" src="'+safeImg(f.thumb)+'" alt="">':'<div class="ex">'+(EXSVG[s.ex]||'')+'</div>')
        +'<div class="sd">'+esc2(s.d)+'</div>'
        +(s.req?'<div class="tagreq">Obligatoire</div>':'<div class="sd" style="opacity:.7">Facultatif</div>')
        +(f&&f.small?'<div class="tagreq">Photo un peu petite : si possible, reprenez-la de plus près.</div>':'')
        +'<input type="file" class="sinp" data-slot="'+s.id+'" accept="'+(s.ex==='video'?'image/*,video/*':'image/*')+'" style="display:none">'
        +'</div>';
    });
    h+='</div>'
      +'<div class="err" id="e_photo">Il manque une photo obligatoire.</div>'
      +'<div style="margin-top:14px"><button class="link" id="nophoto">Je ne peux pas photographier maintenant</button></div>'
      +'<p class="muted">Format : 10 Mo maximum par photo, compression automatique. Vos photos sont conservées avec votre dossier et servent aussi à notre recours contre le transporteur.</p>'
      +navHTML();
    return h;
  };
  function setupPhoto(){
    var G=gabaritFor();
    if(!G){
      var drop=SGID('drop'),inp=SGID('fileinput');
      if(drop&&inp){
        clickable(drop,function(){inp.click();});
        inp.onchange=function(){addFiles(inp.files);inp.value='';};
        drop.ondragover=function(e){e.preventDefault();drop.classList.add('drag');};
        drop.ondragleave=function(){drop.classList.remove('drag');};
        drop.ondrop=function(e){e.preventDefault();drop.classList.remove('drag');addFiles(e.dataTransfer.files);};
      }
      paintFiles();
      return;
    }
    app.querySelectorAll('.slot').forEach(function(el){
      var id=el.dataset.slot;
      el.onclick=function(ev){
        if(ev.target&&ev.target.getAttribute&&ev.target.getAttribute('data-rm'))return;
        var i=el.querySelector('.sinp');if(i)i.click();
      };
    });
    app.querySelectorAll('.sinp').forEach(function(inp){
      inp.onclick=function(e){e.stopPropagation();};
      inp.onchange=function(){
        var id=inp.dataset.slot;
        if(!inp.files||!inp.files.length)return;
        clearSlot(id);
        pushFile(inp.files[0],id,function(){render();});
        inp.value='';
      };
    });
    app.querySelectorAll('.rmv').forEach(function(b){
      b.onclick=function(e){e.stopPropagation();clearSlot(b.dataset.rm);render();};
    });
    var np=SGID('nophoto');
    if(np)np.onclick=function(){
      S.flags.sans_photo=true;S.escal=S.escal||'photos non fournies';
      S.step++;render();
    };
  }

  /* ============================================================
     23. CONTACT
     ============================================================ */
  VIEWS.contact=function(){
    return '<div class="step-label">Coordonnées</div><h2 class="q">Comment vous recontacter ?</h2>'
      +'<p class="sub">Nous vous écrivons à ces coordonnées, et vous recevez le lien de suivi de votre dossier.</p>'
      +'<label class="f">Nom et prénom <span class="req">*</span></label><input type="text" id="nom" value="'+esc2(S.contact.nom||'')+'" placeholder="Prénom Nom">'
      +'<label class="f">Email <span class="req">*</span></label><input type="email" id="cmail" value="'+esc2(S.contact.email||(S.order?S.order.email:''))+'" placeholder="vous@email.fr">'
      +'<label class="f">Téléphone <span class="hint">(pour être rappelé si c\'est plus rapide)</span></label><input type="tel" id="tel" value="'+esc2(S.contact.tel||'')+'" placeholder="06 12 34 56 78">'
      +'<div class="err" id="e_ct">Le nom et l\'email sont nécessaires.</div>'+navHTML('Voir le message final');
  };

  /* ============================================================
     24. MESSAGE FINAL
     ============================================================ */
  function fmtProd(p,concerned,upack){
    if(!p)return '';
    var q=concerned||p.q,pre='';
    if(p.q>1){pre=q+'× ';}
    var sku=skuOf(p),n=packSize(p),suf='';
    if(n&&upack!=null)suf=' (dont '+upack+' unité(s) concernée(s) sur les '+n+' du pack)';
    return pre+p.n+(sku?(' — SKU '+sku):'')+suf;
  }
  function pushBold(v){if(v&&S._bold&&S._bold.indexOf(v)<0)S._bold.push(v);}
  function boldHtml(txt){
    var h=esc2(txt);
    var toks=(S._bold||[]).filter(Boolean).slice().sort(function(a,b){return b.length-a.length;});
    toks.forEach(function(tok){var e=esc2(tok);if(e&&h.indexOf('<b>'+e+'</b>')<0)h=h.split(e).join('<b>'+e+'</b>');});
    return h;
  }
  prodLabel=function(){
    if(!orderMode()){pushBold(S.answers.pfree);return S.answers.pfree||'le produit concerné';}
    return (S.selProducts||[]).map(function(idx,pos){var p=S.order.products[idx];var lab=fmtProd(p,(S.qty[idx]||(p&&p.q)),packSize(p)?upackAt(pos):null);pushBold(lab);return lab;}).join(' et ')||'le produit concerné';
  };
  function techParagraphFor(d){
    if(!d||!d.famille)return '';
    var sf=S.famille,sa=S.answers;
    S.famille=d.famille;S.answers=d.answers||{};
    var t='';try{t=techParagraph();}catch(e){}
    S.famille=sf;S.answers=sa;
    return t;
  }
  var DEC_TXT={
    attendre:"attendre encore, en étant tenu informé",
    reexpedition:"la réexpédition de ma commande",
    remboursement:"le remboursement de ma commande",
    echange:"un échange contre un produit équivalent",
    avoir:"un avoir majoré de 10 %",
    numeraire:"un remboursement sur mon moyen de paiement"
  };
  function linesParagraph(){
    var out=[];
    for(var i in S.lines){
      if(!S.lines.hasOwnProperty(i)||!S.lines[i].on)continue;
      var p=S.order&&S.order.products&&S.order.products[i];if(!p)continue;
      var t=S.lines[i].type,lbl='';
      if(t==='manquant')lbl='non reçu (manquant)';
      else if(t==='qte'){var mxp=packSize(p)||p.q;lbl='reçu en quantité insuffisante'+(S.lines[i].qte!=null&&S.lines[i].qte!==''?' ('+S.lines[i].qte+' reçu(s) sur '+mxp+(packSize(p)?' unités du pack':'')+')':'');}
      else if(t==='mauvais')lbl='ce n\'est pas le bon produit';
      else lbl='problème signalé';
      var nm=fmtProd(p,p.q,null);pushBold(nm);
      out.push('- '+nm+' : '+lbl);
    }
    return out;
  }
  motifParagraph=function(){
    var a=S.answers,f=ful();
    if(S.motif==='casse'){
      var s="J'ai reçu mon colis le "+(frDate(a.recdate)||'(date non précisée)')+". ";
      s+=/^Oui/i.test(a.pack||'')?"L'emballage extérieur était visiblement endommagé (carton écrasé ou déchiré). ":"L'emballage extérieur était intact, mais le produit à l'intérieur est arrivé cassé. ";
      if(a.desc){s+='Concrètement : '+a.desc+'.';pushBold(a.desc);}
      return s.trim();
    }
    if(S.motif==='prepa'){
      var L=linesParagraph();
      var s2=L.length?("Voici les lignes de ma commande qui posent problème :\n"+L.join('\n')):("Il manque un ou plusieurs éléments dans mon colis"+(a.desc?' : '+a.desc:'')+".");
      if(L.length&&a.desc){pushBold(a.desc);s2+="\nJ'ai également reçu un article que je n'avais pas commandé : "+a.desc+".";}
      return s2;
    }
    if(S.motif==='retract'){
      var s3="Je souhaite retourner ce produit. Motif : "+(a.rmotif||'non précisé')+". Le produit est "+lc(a.used||'(état non précisé)')+".";
      if(a.desc){s3+=' Précision : '+a.desc+'.';pushBold(a.desc);}
      var j=joursDepuisReception();
      if(j!=null)s3+=" Réception il y a "+j+" jour(s).";
      return s3;
    }
    if(S.motif==='nonrecu'){
      var s4=(f.carrier||'Le transporteur')+" indique avoir livré mon colis"
        +(f.delivered_at?" le "+frDate(f.delivered_at):"")
        +(f.tracking?" (suivi "+f.tracking+")":"")+", or je ne l'ai jamais reçu.";
      if(f.tracking)pushBold(f.tracking);
      s4+=" J'ai vérifié auprès de mes voisins, dans les abords de mon domicile, et personne d'autre au foyer ne l'a réceptionné.";
      return s4;
    }
    if(S.motif==='suivi'){
      var e=suiviEtat();
      var s5="Ma commande n'est pas arrivée dans le délai annoncé"+(ship().label?" pour une livraison « "+ship().label+" »":"")+".";
      var lc2=colisList();
      if(lc2.length>1){
        s5+=" La commande a été expédiée en "+lc2.length+" colis : "+lc2.map(function(c){return c.tracking;}).join(', ')+".";
        lc2.forEach(function(c){pushBold(c.tracking);});
      }else if(f.tracking){s5+=" Numéro de suivi "+f.tracking+".";pushBold(f.tracking);}
      if(f.last_event&&f.last_event.label)s5+=" Dernier événement : "+f.last_event.label+(f.last_event.date?" le "+frDate(f.last_event.date):"")+".";
      if(e.cas==='bloque'||e.cas==='jamais_pris')s5+=" Le suivi est bloqué.";
      return s5;
    }
    if(S.motif==='conseil'||S.motif==='garantie'){pushBold(a.desc);return 'Ma question : « '+(a.desc||'')+' ».';}
    if(S.motif==='stock'){pushBold(a.pfree);return "Je cherche à savoir quand « "+(a.pfree||'ce produit')+" » sera de nouveau disponible"+(a.qte?" (quantité souhaitée : "+a.qte+")":"")+". J'ai besoin d'une date pour organiser mon chantier.";}
    if(S.motif==='autre'){pushBold(a.libre);return a.libre||'';}
    if(S.motif==='facture')return "Je n'arrive pas à récupérer ma facture depuis mon compte client.";
    if(S.motif==='devis')return (a.desc||"Je souhaite être recontacté pour ma demande.");
    return '';
  };
  buildMessage=function(){
    S._bold=[];
    var P=[];P.push('Bonjour,');
    var noProd=(S.motif==='suivi'||S.motif==='nonrecu'||S.motif==='facture'||S.motif==='devis'||S.motif==='autre');
    var intro;
    if(noProd){
      intro='Je vous contacte au sujet de ma commande'+(S.order?' '+S.order.id+' du '+frDate(S.order.date):(S.answers.ordlibre?' '+S.answers.ordlibre:''));
      if(S.order)pushBold(S.order.id);
      intro+='.';
    }else{
      intro='Je vous contacte au sujet de '+prodLabel();
      if(S.order&&S.order.id){intro+=", que j'ai commandé le "+frDate(S.order.date)+' (commande '+S.order.id+')';pushBold(S.order.id);}
      if(S.motif==='defaut')intro+=(selCount()>1?'. Ces produits rencontrent un problème.':'. Ce produit rencontre un problème.');
      else intro+='.';
    }
    P.push(intro);

    if(S.motif==='defaut'){
      var multi=posList().length>1;
      posList().forEach(function(pos){
        var d=S.diagByProd[prodKeyAt(pos)];if(!d)return;
        var a=d.answers||{};pushBold(a.sympt);pushBold(lc(a.sympt));
        var when=a.when?('Le problème est apparu '+lc(a.when)+'. '):'';
        var t=techParagraphFor(d);
        var head=(multi?'Concernant '+fmtProd(productAtPos(pos),qtyAt(pos),packSize(productAtPos(pos))?upackAt(pos):null)+' : ':'');
        var again=(a.again&&/^Non/i.test(a.again))?(' '+a.again+'.'):'';
        var body=(head+when+(t||'')+again).trim();
        if(body)P.push(body);
      });
      var tried=[];
      posList().forEach(function(pos){var dr=S.diagResult[pos];if(dr&&dr.steps)dr.steps.forEach(function(x){if(tried.indexOf(x)<0)tried.push(x);});});
      if(tried.length)P.push("J'ai suivi le diagnostic proposé par votre formulaire ("+tried.slice(0,4).join(' ; ')+") sans que cela résolve le problème.");
      else P.push("J'ai déjà tenté un dépannage de base (couper le courant une dizaine de secondes, vérifier l'alimentation), sans succès.");
      var g=productAtPos(0)?garantieDe(productAtPos(0)):{};
      if(g.known)P.push(g.in?("Selon la date d'achat, ce produit est encore sous garantie ("+g.reste+" mois restants).")
                              :("Ce produit est hors garantie ("+ageTexte(g.age)+" depuis l'achat). Je sollicite un geste commercial."));
    }else{
      var m=motifParagraph();if(m)P.push(m);
    }
    if(S.answers.libre&&S.motif!=='autre'){
      P.push('Ce que j\'avais écrit au départ : « '+S.answers.libre+' ».');
    }
    if(S.attest&&S.attest.text){
      P.push('Attestation sur l\'honneur : « '+S.attest.text+' » (cochée le '+S.attest.at+').');
    }
    if(S.decision&&DEC_TXT[S.decision]){
      P.push('Ce que je souhaite : '+DEC_TXT[S.decision]+'.');
      pushBold(DEC_TXT[S.decision]);
    }
    var G=gabaritFor();
    if(G&&S.files.length){
      var noms=S.files.filter(function(f){return f.slot;}).map(function(f){
        var s=null;G.forEach(function(x){if(x.id===f.slot)s=x.t;});return s||f.name;
      });
      P.push('Je joins '+S.files.length+' photo'+(S.files.length>1?'s':'')+(noms.length?' : '+noms.join(' ; '):'')+'.');
    }else{
      P.push(S.files.length?('Je joins '+S.files.length+' fichier'+(S.files.length>1?'s':'')+" à l'appui de ma demande."):"Je n'ai pas joint de photo pour le moment.");
    }
    P.push("Merci d'avance pour votre aide.");
    P.push('Cordialement,');
    P.push((S.contact.nom||'')+(S.contact.email?'  ·  '+S.contact.email:'')+(S.contact.tel?'  ·  '+S.contact.tel:''));
    return P;
  };

  VIEWS.recap=function(){
    var txt=buildMessage().join(String.fromCharCode(10,10));
    var html=boldHtml(txt);
    var eng=delaiSAV();
    return ''
    +'<div class="step-label">Étape finale · Vérification</div>'
    +'<h2 class="q">Voici votre demande, rédigée pour le service client</h2>'
    +'<p class="sub">Vos réponses ont été réunies en un message complet : vous n\'aurez rien à réexpliquer. Vous pouvez le <b>modifier</b> avant l\'envoi.</p>'
    +'<div class="msgview" id="msgview">'+html+'</div>'
    +'<textarea id="msgedit" class="msgedit" rows="14" style="display:none">'+esc2(txt)+'</textarea>'
    +'<div style="margin-top:10px"><button class="link" id="editmsg">✏️ Modifier le message</button></div>'
    +'<div class="stat ok" style="margin-top:18px"><h4>Ce qui se passe après l\'envoi</h4>'
      +'<p>Votre dossier est créé avec un numéro et un lien de suivi. Un conseiller vous répond <b>'+eng+'</b>'
    +(S.motif==='casse'||S.motif==='nonrecu'?' — les litiges transport sont traités en priorité.':'.')+'</p></div>'
    +'<div class="nav"><button class="btn ghost" id="back">← Retour</button><button class="btn primary" id="send">Envoyer ma demande →</button></div>';
  };

  function sendErr(msg){
    var host=SGID('send');var e=SGID('e_send');
    if(!e&&host&&host.parentNode&&host.parentNode.parentNode){
      e=document.createElement('div');e.className='err';e.id='e_send';
      host.parentNode.parentNode.insertBefore(e,host.parentNode);
    }
    if(e){e.textContent=msg||'Envoi impossible pour le moment. Réessaie, ou écris-nous à contact@silumen.com.';e.style.display='block';}
  }
  function payloadLignes(){
    var out=[];
    for(var i in S.lines){
      if(!S.lines.hasOwnProperty(i)||!S.lines[i].on)continue;
      var p=S.order&&S.order.products&&S.order.products[i];if(!p)continue;
      out.push({sku:skuOf(p),title:p.n,qty_ordered:p.q,pack_size:packSize(p),qty_received:S.lines[i].qte,type:S.lines[i].type});
    }
    return out;
  }
  function payloadGarantie(){
    if(!orderMode())return null;
    var p=productAtPos(0);if(!p)return null;
    var g=garantieDe(p);
    return {statut:g.known?(g.in?'sous_garantie':'hors_garantie'):'inconnu',duree_mois:g.mois,age_mois:g.age,date_achat:g.date};
  }
  function bindSend(){
    var btn=SGID('send');if(!btn)return;
    btn.onclick=function(){
      if(S._sending)return;
      var ep=dset('submit','');
      var photos=S.files.filter(function(f){return f.data;}).map(function(f){return {name:f.name||'photo.jpg',type:f.type||'image/jpeg',data:f.data,slot:f.slot||''};});
      var msgEl=SGID('msgedit');
      var msgText=msgEl?msgEl.value:buildMessage().join(String.fromCharCode(10,10));
      var f=ful();
      var payload={
        kind:'ticket',
        branche:S.motif||'',
        motif:(MOTIFS[S.motif]&&MOTIFS[S.motif].t)||S.motif||'',
        sortie:(S.sortie||'S3'),
        order:(S.order&&S.order.id)||'',
        order_date:(S.order&&S.order.date)||'',
        channel:(S.order&&S.order.channel)||'',
        compte_client:!!S.cust,
        source_commande:(S.order&&S.order.source)||(S.order?'lookup':''),
        email:(S.contact.email||(S.order&&S.order.email)||'').trim(),
        name:(S.contact.nom||'').trim(),
        phone:(S.contact.tel||'').trim(),
        skus:posList().map(function(pos){var p=productAtPos(pos);return p?skuOf(p):'';}).filter(Boolean),
        produits:posList().map(function(pos){var p=productAtPos(pos);if(!p)return null;return {sku:skuOf(p),title:p.n,qty_ordered:p.q,qty_concerned:qtyAt(pos),pack_size:packSize(p),units_concerned:packSize(p)?upackAt(pos):null};}).filter(Boolean),
        lignes:payloadLignes(),
        garantie:payloadGarantie(),
        decision:S.decision||'',
        attestation:S.attest||null,
        tracking:f.tracking||'',carrier:f.carrier||'',fulfillment_status:f.status||'',
        colis:colisList(),
        shipping:ship(),
        diagnostic:S.diagResult||{},
        reponses:S.diagByProd||{},
        flags:S.flags||{},
        escalade:S.escal||'',
        engagement:engagement(1),
        message:msgText,
        photos:photos
      };
      if(!ep){
        /* Reglage d'envoi vide : on ne simule PAS un succes. Un client qui lit
           « votre demande est enregistree » alors que rien n'est parti est le pire
           scenario possible — il attend, puis il appelle en colere. */
        sendErr('Le formulaire n\'est pas encore relié à notre service client. '
          +'Copiez votre message et envoyez-le à contact@silumen.com, nous le traiterons normalement.');
        return;
      }
      S._sending=true;btn.disabled=true;btn.textContent='Envoi en cours...';
      var ctrl=('AbortController' in window)?new AbortController():null;
      var timer=setTimeout(function(){if(ctrl)ctrl.abort();},45000);
      function relacher(){S._sending=false;clearTimeout(timer);btn.disabled=false;btn.textContent='Envoyer ma demande →';}
      fetch(ep,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:ctrl?ctrl.signal:undefined})
        .then(function(r){if(!r.ok)throw 0;return r.json().catch(function(){return {};});})
        .then(function(d){clearTimeout(timer);S._sending=false;S._case=d||{};finir(VIEWS.done());})
        .catch(function(){relacher();sendErr();});
    };
  }
  VIEWS.done=function(){
    var c=S._case||{};
    var quoi;
    if(S.decision==='reexpedition')quoi='Votre demande de réexpédition part avec votre dossier : un conseiller la valide et vous transmet le suivi du nouveau colis.';
    else if(S.decision==='remboursement'||S.decision==='numeraire')quoi='Votre demande de remboursement part avec votre dossier. Le délai légal de 14 jours calendaires s\'applique, nous faisons généralement plus court.';
    else if(S.decision==='avoir')quoi='Votre demande d\'avoir majoré de 10 % part avec votre dossier : un conseiller vous confirme le montant crédité.';
    else if(S.decision==='echange')quoi='Votre demande d\'échange part avec votre dossier : un conseiller confirme la référence et le suivi de l\'envoi.';
    else if(S.decision==='attendre')quoi='Nous relançons le transporteur et vous tenons informé. Sans évolution, nous revenons vers vous avec une réexpédition ou un remboursement.';
    else quoi='Un conseiller traite votre dossier avec tout le contexte : vous n\'aurez rien à réexpliquer.';
    return '<div class="done"><div class="big">✓</div><h2 class="q">Votre demande est enregistrée</h2>'
      +(c.case_id?'<p class="sub">Votre dossier : <b>'+esc2(c.case_id)+'</b></p>':'')
      +'<p class="sub">'+quoi+'</p>'
           +'<p>Réponse'+(S.contact.email?' à <b>'+esc2(S.contact.email)+'</b>':'')+' <b>'+delaiSAV()+'</b>.</p>'
      +(safeUrl(c.track_url)?'<p><a class="btn ghost" href="'+esc2(safeUrl(c.track_url))+'" target="_blank" rel="noopener">Suivre mon dossier</a></p>'
        :'<p class="muted">Vous recevez par mail le lien de suivi de votre dossier : vous voyez où il en est à chaque étape, sans avoir à nous relancer.</p>')
      +'</div>';
  };

  /* ============================================================
     25. BLOCS REUTILISABLES
     ============================================================ */
  function ckHtml(id,label){
    return '<label class="ck"><input type="checkbox" class="vck" data-ck="'+id+'" '+(S.checks[id]?'checked':'')+'><span>'+esc2(label)+'</span></label>';
  }
  function decHtml(list){
    return list.map(function(d){
      return '<div class="dec '+(S.decision===d[0]?'sel':'')+'" data-dec="'+d[0]+'">'
        +'<div class="r"></div><div><div class="t">'+esc2(d[1])+'</div><div class="d">'+esc2(d[2])+'</div></div></div>';
    }).join('');
  }
  function bindDec(){
    app.querySelectorAll('.dec').forEach(function(el){
      clickable(el,function(){S.decision=el.dataset.dec;render();});
    });
  }
  function bindChecks(){
    app.querySelectorAll('.vck').forEach(function(c){
      c.onchange=function(){S.checks[c.dataset.ck]=c.checked?1:0;};
    });
    var att=SGID('att');
    if(att)att.onchange=function(){
      if(att.checked){
        S.attest={text:(S.motif==='nonrecu'?attestNonRecu():attestPrepa()),
          at:new Date().toLocaleString('fr-FR'),branche:S.motif};
      }else{S.attest=null;}
    };
  }

  /* ============================================================
     25bis. REPRISE DE PARCOURS ET LIENS PROFONDS
     ============================================================ */
  /* Brouillon local : ni coordonnees, ni photos. Un poste partage ne doit pas
     laisser lire l'email ou le telephone du client precedent. */
  var DKEY='silamp_sav_draft', DTTL=43200000; /* 12 h */
  function saveDraft(){
    try{
      if(!S.motif||S.step<1)return;
      localStorage.setItem(DKEY,JSON.stringify({
        t:Date.now(),motif:S.motif,step:S.step,order:S.order,noOrder:S.noOrder,
        selProducts:S.selProducts,qty:S.qty,upack:S.upack,answers:S.answers,
        diagByProd:S.diagByProd,lines:S.lines,checks:S.checks,attest:S.attest,
        decision:S.decision,flags:S.flags
      }));
    }catch(e){}
  }
  function loadDraft(){
    try{
      var r=localStorage.getItem(DKEY);if(!r)return null;
      var d=JSON.parse(r);
      if(!d||!d.t||(Date.now()-d.t)>DTTL){localStorage.removeItem(DKEY);return null;}
      return d;
    }catch(e){return null;}
  }
  function clearDraft(){try{localStorage.removeItem(DKEY);}catch(e){}}
  function applyDraft(d){
    S.motif=d.motif;S.step=d.step||1;S.order=d.order||null;S.noOrder=!!d.noOrder;
    S.selProducts=d.selProducts||[];S.qty=d.qty||{};S.upack=d.upack||{};
    S.answers=d.answers||{};S.diagByProd=d.diagByProd||{};S.lines=d.lines||{};
    S.checks=d.checks||{};S.attest=d.attest||null;S.decision=d.decision||null;
    S.flags=d.flags||{};S.files=[];
    S._draft=null;render();
  }
  function draftHtml(){
    var d=S._draft;if(!d||S.motif)return '';
    var m=MOTIFS[d.motif];if(!m)return '';
    return '<div class="draft"><b>Vous aviez commencé une demande</b> — '+esc2(m.t)
      +(d.order&&d.order.id?' sur la commande '+esc2(d.order.id):'')+'.'
      +'<div class="actions" style="margin-top:12px">'
      +'<button class="btn primary" id="drep">Reprendre où j\'en étais →</button>'
      +'<button class="btn ghost" id="dnew">Repartir de zéro</button></div>'
      +'<p class="muted">Ni vos photos ni vos coordonnées ne sont conservées : elles seront à ressaisir.</p></div>';
  }
  /* lien profond : /pages/contact?motif=defaut&order=%23291234&product=ruban-led-24v */
  function deepLink(){
    try{
      var qs=(document.location.search||'').replace(/^\?/,'');
      if(!qs)return;
      var P={};
      qs.split('&').forEach(function(kv){
        var i=kv.indexOf('=');if(i<0)return;
        P[decodeURIComponent(kv.slice(0,i))]=decodeURIComponent(kv.slice(i+1).replace(/\+/g,' '));
      });
      if(P.order)S.answers.ordlibre=P.order;
      if(P.product)S.answers.pfree=P.product;
      if(P.sku)S.answers.skulibre=P.sku;
      if(P.motif&&MOTIFS[P.motif]){S.motif=P.motif;S.step=1;S._draft=null;}
    }catch(e){}
  }

  /* ============================================================
     26. FLOW
     ============================================================ */
  flow=function(){
    /* La porte d'entree passe avant tout le reste. On remet l'etape a 0 ici :
       flow() est appele par render() AVANT la lecture de S.step. */
    if(gateActive()){S.step=0;return ['login'];}
    var m=S.motif;
    if(!m)return ['motif'];
    if(m==='defaut'){
      var f=['motif','id','product','diag','result'];
      if(garantieOut())f.push('hg');
      return f.concat(['photo','contact','recap']);
    }
    var F={
      suivi:  ['motif','id','suivi','contact','recap'],
      nonrecu:['motif','id','nonrecu','contact','recap'],
      prepa:  ['motif','id','prepa','photo','contact','recap'],
      casse:  ['motif','id','product','q_casse','photo','contact','recap'],
      retract:['motif','id','product','q_retract','sauvetage','contact','recap'],
      conseil:['motif','conseil','gresult','contact','recap'],
      facture:['motif','id','facture','contact','recap'],
      devis:  ['motif','devis','contact','recap'],
      stock:  ['motif','stock','contact','recap'],
      autre:  ['motif','autre','autreres','contact','recap']
    };
    return F[m]||['motif','contact','recap'];
  };

  /* ============================================================
     27. COLLECTE ET VALIDATION
     ============================================================ */
  function g(id){var el=SGID(id);return el?el.value.trim():'';}
  function gf(id){var el=SGID('f_'+id);return el?el.value.trim():'';}

  collect=function(key){
    if(key==='product'&&(!orderMode()||sansDetail()))S.answers.pfree=g('pfree');
    if(key==='prepa'){
      S.answers.desc=gf('desc');
      if(!orderMode())S.answers.pfree=g('pfree');
    }
    if(key==='q_casse'){S.answers.recdate=gf('recdate');S.answers.pack=gf('pack');S.answers.desc=gf('desc');}
    if(key==='q_retract'){S.answers.rmotif=gf('rmotif');S.answers.used=gf('used');S.answers.desc=gf('desc');}
    if(key==='conseil'){S.answers.desc=gf('desc');S.answers.pfree=g('pfree');}
    if(key==='autre'){S.answers.libre=gf('libre');S.answers.ordlibre=g('ord2');}
    if(key==='stock'){S.answers.pfree=g('pfree');S.answers.qte=gf('qte');var m=SGID('s_mail');if(m&&m.value.trim())S.contact.email=m.value.trim();}
    if(key==='suivi'){var m2=SGID('s_mail'),t2=SGID('s_tel');if(m2)S.contact.email=m2.value.trim();if(t2)S.contact.tel=t2.value.trim();}
    if(key==='contact'){S.contact.nom=g('nom');S.contact.email=g('cmail');S.contact.tel=g('tel');}
  };

  validateAndNext=function(key){
    collect(key);clearInval();
    if(key==='motif'&&!S.motif){showErr('e_motif');return;}
    if(key==='id'&&!(S.order||S.noOrder)){showErr('e_id');return;}
    if(key==='product'){
      if((!orderMode()||sansDetail())&&!S.answers.pfree){showErr('e_prod');invalid(['pfree']);return;}
      if(orderMode()&&!sansDetail()&&S.selProducts.length===0){showErr('e_prod');return;}
    }
    if(key==='prepa'){
      if(!orderMode()||sansDetail()){
        var miss0=[];if(!S.answers.pfree)miss0.push('pfree');if(!S.answers.desc)miss0.push('f_desc');
        if(miss0.length){showErr('e_prepa');invalid(miss0);return;}
      }else{
        var any=false;
        for(var i in S.lines){if(S.lines.hasOwnProperty(i)&&S.lines[i].on&&S.lines[i].type)any=true;}
        if(!any&&!S.answers.desc){showErr('e_prepa');return;}
        if(!S.attest){showErr('e_prepa');return;}
      }
    }
    if(key==='diag'){
      collectDiag();
      var missD=diagManquants();
      if(missD.length){
        showErr('e_q');
        missD.forEach(function(id){var el=SGID(id);if(el)el.classList.add('inval');});
        var f0=SGID(missD[0]);if(f0){if(f0.focus)f0.focus();if(f0.scrollIntoView)f0.scrollIntoView({block:'center',behavior:'smooth'});}
        return;
      }
      S.diagResult={};
    }
    if(key==='q_casse'){
      var missC=[];
      if(!S.answers.recdate)missC.push('f_recdate');
      if(!S.answers.pack)missC.push('f_pack');
      if(!S.answers.desc)missC.push('f_desc');
      if(missC.length){showErr('e_q');invalid(missC);return;}
    }
    if(key==='nonrecu'){
      if(!(S.checks.v1&&S.checks.v2&&S.checks.v3)||!S.attest){showErr('e_nr');return;}
      /* La reexpedition est la solution par defaut : sur un colis non remis, elle
         satisfait notre obligation de livraison. Le remboursement n'est pas propose,
         mais reste accessible en le demandant a un conseiller. */
      if(!S.decision)S.decision='reexpedition';
      S.sortie='S2';
    }
    if(key==='q_retract'){
      var missR=[];if(!S.answers.rmotif)missR.push('f_rmotif');if(!S.answers.used)missR.push('f_used');
      if(missR.length){showErr('e_q');invalid(missR);return;}
    }
    if(key==='sauvetage'&&!S.decision){showErr('e_dec');return;}
    if(key==='conseil'&&!S.answers.desc){showErr('e_q');invalid(['f_desc']);return;}
    if(key==='autre'&&!S.answers.libre){showErr('e_libre');invalid(['f_libre']);return;}
    if(key==='photo'){
      var G=gabaritFor();
      if(G){
        var manque=G.filter(function(s){return s.req&&!fileInSlot(s.id);});
        if(manque.length){showErr('e_photo');return;}
      }
    }
    if(key==='contact'){
      var missT=[];if(!S.contact.nom)missT.push('nom');if(!validEmail(S.contact.email))missT.push('cmail');
      if(missT.length){showErr('e_ct');invalid(missT);return;}
    }
    S.step++;render();
  };

  /* ============================================================
     28. WIRING
     ============================================================ */
  wire=function(key){
    var back=SGID('back');
    if(back)back.onclick=function(){if(S.step>0){S.step--;render();}};
    var next=SGID('next');
    if(next)next.onclick=function(){validateAndNext(key);};

    if(key==='login'){
      var as=SGID('autresujet');
      if(as)as.onclick=function(){S.motif=null;S.step=0;render();};
      return;
    }
    if(key==='motif')setupMotif();
    if(key==='id')setupId();
    if(key==='product')setupProduct();
    if(key==='result')setupResult();
    if(key==='hg')setupHg();
    if(key==='suivi'){bindChecks();setupSuivi();}
    if(key==='nonrecu'){
      bindChecks();bindDec();
      var au=SGID('autresol');
      if(au)au.onclick=function(){
        if(!(S.checks.v1&&S.checks.v2&&S.checks.v3)||!S.attest){showErr('e_nr');return;}
        S.decision='';S.escal='le client souhaite une autre solution qu\'une réexpédition';
        S.sortie='S3';S.step++;render();
      };
    }
    if(key==='prepa'){setupPrepa();bindChecks();}
    if(key==='sauvetage')setupSauvetage();
    if(key==='gresult')setupGresult();
    if(key==='autreres')setupAutreres();
    if(key==='facture')setupFacture();
    if(key==='devis')setupDevis();
    if(key==='stock')setupStock();
    if(key==='photo')setupPhoto();
    if(key==='recap'){
      bindSend();
      var em=SGID('editmsg');
      if(em)em.onclick=function(){
        var mv=SGID('msgview'),me2=SGID('msgedit');
        if(mv)mv.style.display='none';if(me2)me2.style.display='block';em.style.display='none';
      };
    }
  };

  var _reset=reset;
  reset=function(){
    S.diagByProd={};S.qty={};S.upack={};S.diagResult={};S.lines={};S.checks={};
    S.attest=null;S.decision=null;S.alt=null;S.flags={};S.escal='';S.sortie='S3';
    S._lastLk=null;S._case=null;S.res={};S._resAsked={};S._resRender=0;S._iaFait=null;S._iaRep='';S._iaEsc=false;S._iaSrc=[];S._iaCount=0;S._draft=null;S._manual=false;S._colisFait=false;S._toutesCmd=false;S.srcProduit=null;clearDraft();resetTurnstile();_reset();
    try{
      if(S.cust){
        S.contact.nom=S.cust.name||'';S.contact.email=S.cust.email||'';S.contact.tel=S.cust.phone||'';
      }
    }catch(e){}
  };

  var _render=render;var _lastStep=-1;
  function numeroterEtape(){
    try{
      var f=flow(),el=app.querySelector('.step-label');
      if(!el||f.length<3)return;
      var n=Math.min(S.step+1,f.length),N=f.length,t=el.textContent||'';
      if(/^\s*Étape\s+finale/i.test(t))return;
      if(/^\s*Étape\s*\d+/.test(t))el.textContent=t.replace(/^\s*Étape\s*\d+(\s*sur\s*\d+)?/,'Étape '+n+' sur '+N);
      else el.textContent='Étape '+n+' sur '+N+' · '+t;
    }catch(e){}
  }
  render=function(){
    _render();
    numeroterEtape();
    saveDraft();
    try{
      if(S.step!==_lastStep){
        var first=(_lastStep===-1);_lastStep=S.step;
        if(!first){var root=document.querySelector('#sav-root');if(root&&root.scrollIntoView)root.scrollIntoView({block:'start',behavior:'smooth'});}
      }
    }catch(e){}
  };

  try{
    if(S.cust){
      if(S.cust.name&&!S.contact.nom)S.contact.nom=S.cust.name;
      if(S.cust.email&&!S.contact.email)S.contact.email=S.cust.email;
      if(S.cust.phone&&!S.contact.tel)S.contact.tel=S.cust.phone;
    }
  }catch(e){}
  /* ------------------------------------------------------------------
     v33 — mise en page appliquee depuis le JS
     La section Liquid n'est pas toujours redeployee en meme temps que ce
     fichier. Les deux retouches ci-dessous s'appliquent donc ici, et sont
     idempotentes : si la section a deja ete mise a jour, elles ne font rien.
     ------------------------------------------------------------------ */
  try{
    /* 1. le bloc de reassurance passe SOUS le formulaire */
    var _wrap=ROOT&&ROOT.querySelector('.wrap');
    var _reas=ROOT&&ROOT.querySelector('.reassure');
    if(_wrap&&_reas&&_reas.parentNode&&(_reas.compareDocumentPosition(_wrap)&4)){
      _wrap.parentNode.insertBefore(_reas,_wrap.nextSibling);
    }
  }catch(e){}
  try{
    /* 2. derniere question de la FAQ : le telephone */
    var _panel=ROOT&&ROOT.querySelector('.faq .panel');
    if(_panel&&!/t[ée]l[ée]phone/i.test(_panel.textContent||'')){
      var TEL=dset('tel','01 82 88 32 75');
      /* Deux plages distinctes : le vendredi ferme a 12h30. */
      var HOR1=dset('horairesSemaine','de 8h30 à 12h30 et de 14h00 à 17h00');
      var HOR2=dset('horairesVendredi','de 8h30 à 12h30 et de 14h00 à 17h00');
      var _d=document.createElement('details');
      _d.innerHTML='<summary>Comment nous joindre par téléphone&nbsp;?</summary>'
        +'<div class="fq-a">Notre service client répond au <b><a href="tel:+33'
        +esc2(TEL.replace(/[^0-9]/g,'').replace(/^0/,''))+'">'+esc2(TEL)+'</a></b>, '
        +'du lundi au jeudi '+esc2(HOR1)+', et le vendredi '+esc2(HOR2)+'.<br>'
        +'Pour une demande liée à une commande, le formulaire ci-dessus reste plus rapide : '
        +'il transmet en une fois votre commande, votre garantie et vos pièces jointes, '
        +'là où un appel nous oblige à vous les redemander. Si nous ne pouvons pas prendre '
        +'votre appel, laissez votre demande ici : elle sera traitée dans l\'ordre d\'arrivée, '
        +'sans que vous ayez à rappeler.</div>';
      _panel.appendChild(_d);
    }
  }catch(e){}
  S.step=0;S.motif=null;S._draft=loadDraft();
  deepLink();
  if(typeof render==='function')render();
})();